const brand = sessionStorage.getItem('brand');
export const botBuilder = {
  canvas: {
    chatflowBuilderLoading: 'Chatflow Builder laddar...',
    slowNetworkDetected: 'Långsam nätverksdetektion',
    editYourChatFlow: 'Redigera din chattflöde',
    seeHowToUse: 'Se hur man använder',
    help: 'Hjälp',
    classicBuilder: 'Klassisk byggare',
    visualiseFlow: 'Visualisera flöde',
    testLiveOnTelegramWeb: 'Testa Live på Telegram Web',
    testFlow: 'Testflöde',
    importTemplate: 'Importera mall',
    landingPageBotReview: 'Landningssida Bot Förhandsvisning',
    install: 'Installera',
    testLiveOnMessengerWeb: 'Testa Live på Messenger Web',
    testLiveOnWhatsappWeb: 'Testa Live på WhatsApp Web',
    testLiveOnInstagramWeb: 'Testa Live på Instagram Web',
    seeAllChatFlow: 'Se alla chattflöden',
    launchDemoModal: 'Starta demo-modal',
    selectATemplateToKickStartYourBot:
      'Välj en mall för att kicka igång din bot',
    hireChatBotDesigner: 'Anlita Chatbot Designer',
    recommendedForYou: 'Rekommenderat för dig',
    useTemplate: 'Använd mall',
    exportStatus: 'Exportstatus',
    flowExport: 'Flödesexport',
    download: 'Ladda ner',
    importFlow: 'Importera flöde',
    beforeYouStartUploadPleaseMakeSure:
      'Innan du börjar ladda upp, se till att',
    ponit1: '1. Den maximala filstorleken för uppladdningsgränsen är 20 MB',
    point2: '2. Filformatet ska vara i JSON',
    selectFile: 'Välj fil',
    preview: 'Förhandsgranska',
    test: 'Testa',
    OopsIntegrationAreNotAvailable:
      'Oops! Integrationer är inte tillgängliga i ',
    pleaseUpgradeTo: ' Vänligen uppgradera till ',
    planForIntegration: ' för integrationer.',
    areYouSure: 'Är du säker?',
    yesUseTemplate: 'Ja, använd mallen!',
    importTemplateDescription:
      'Importera denna mall kommer att ersätta det befintliga chattflödet. Alla osparade ändringar kommer att gå förlorade.',
    placeholders: {
      searchTemplateYouNeed: 'Sök efter den mall du behöver',
    },
    noDataFound: {
      botFlow: 'Botflöde',
      noBotFlowAddedYet: 'Inget botflöde har lagts till ännu!',
      templates: 'Mallar',
      noTemplatesFound: 'Ingen mall hittad!',
    },
    appTooltip: {
      exportFlow: 'Exportera flöde',
      importFlow: 'Importera flöde',
      clickToViewChatFlow:
        'Klicka för att se chattflödet i drag-and-drop-byggaren',
      clickToPreviewChatFlow: 'Klicka för att förhandsgranska chattflödet',
      clickToViewChatFlowAsFlowDiagram:
        'Klicka för att se chattflödet som ett flödesschema',
      clickToTestChatFlow: 'Klicka för att testa chattflödet',
      clickToSelectAndImportTemplate:
        'Klicka för att välja och importera den mall som passar din verksamhet bäst.',
      clickToInstallYourBotToSelectedPlatform:
        'Klicka för att installera din bot på den valda plattformen',
      clickToTestDefaultFlowOfTelegramBot:
        'Klicka för att testa standardflödet för din bot på telegram web',
      clickToTestDefaultFlowOfFacebookBot:
        'Klicka för att testa standardflödet för din bot på facebook web',
      clickToTestDefaultFlowOfWhatsappBot:
        'Klicka för att testa standardflödet för din bot på whatsapp web',
      clickToTestDefaultFlowOfInstagramBot:
        'Klicka för att testa standardflödet för din bot på instagram web',
    },
  },
  createNewBot: {
    createNewBot: 'Skapa ny bot',
    stepOneOfTwo: 'Steg 1 av 2',
    selectThePlatform: 'Välj plattformen',
    selectTheBotType: 'Välj Bot-typen',
    aiBasedChatbot: 'AI-baserad chattbot',
    ruleBasedChatBot: 'Regelbaserad chattbot',
    webPlatforms: 'Webbplattformar',
    websiteChatBot: 'Webbplats Chatbot',
    withLiveChat: '(Med Live Chat)',
    landingPageBot: 'Landningssida Bot',
    liveChatWidget: 'Live Chat Widget',
    onlyLiveChat: '(Endast Live Chat)',
    socialPlatforms: 'Sociala plattformar',
    whatsappChatBot: 'WhatsApp Chatbot',
    telegramChatBot: 'Telegram Chatbot',
    facebookChatBot: 'Facebook Chatbot',
    instagramChatBot: 'Instagram Chatbot',
    selectBotType: 'Välj Bot-typ',
    selectProblem: 'Välj problemet du vill lösa',
    leadGeneration: 'Leadgenerering',
    customerSupport: 'Kundsupport',
    appointmentBooking: 'Bokning av möten',
    marketingAutomation: 'Marknadsföringsautomation',
    ecommerceWebsite: 'E-handelswebbplats',
    otherUseCase: 'Andra',
    back: 'Tillbaka',
    typeDomainUrl: 'Skriv din webbplats URL för verifiering.',
    dataSourceForChatBotTraining: 'Datakälla för chattbotträning',
    upload: 'Ladda upp',
    uploadDocuments: 'Ladda upp dokument',
    uploadDocument: 'Ladda upp dokument',
    selectFile: 'Välj fil',
    continue: 'Fortsätt',
    websiteUrl: 'Skriv din webbplats URL',
    skipNow: 'Hoppa över nu',
    completeTheExistingBotSetup: 'Slutför den befintliga botinstallationen',
    youHaveAlreadyCreatedOneWhatsAppBot:
      'Du har redan skapat en WhatsApp Bot. Slutför inställningen för den för att skapa en ny.',
    completeSetup: 'Slutför inställningen',
    seeHowToUse: 'Se hur du använder',
    help: 'Hjälp',
    fbBot: {
      createNewBot: 'Skapa ny bot',
      help: 'Hjälp',
      back: 'Tillbaka',
      step: 'Steg ',
      of3: ' av 3',
      loginWithFacebook: 'Logga in med Facebook',
      asPerLatestChangesInFacebookPolicy:
        'Enligt de senaste ändringarna i Facebooks policy måste ägaren till Facebook-boten ha en roll som "chef" eller högre för att få tillgång till alla funktioner i Facebook-sidan.',
      login: 'Logga in',
      connectFacebookBot: 'Anslut Facebook Bot',
      connectBotWithYourFacebookPagesAnd:
        'Anslut Bot med dina Facebook-sidor och ',
      exploreTruePowerOfFacebook: 'utforska den verkliga kraften hos Facebook',
      connect: 'Anslut',
      connected: 'Ansluten',
      createNewPage: 'Skapa ny sida',
      refreshPageList: 'Uppdatera sidolistan',
      thisPageIsSuccessfullyIntegratedWith:
        'Den här sidan är framgångsrikt integrerad med ',
      yourMessagesFromMessengerWillAppearIn:
        '. Dina meddelanden från Messenger kommer att visas i ',
      inbox: ' Inkorgen',
      continueToBotConfiguration: 'Fortsätt till Bot-konfiguration',
      welcomeToBrandNameWeAreHereToHelpYou: `Välkommen till ${brand}. Vi är här för att hjälpa dig.`,
      letsTryYourBotAndSeeHowItWorks: `Låt oss prova din bot och se hur den fungerar! Klicka på "Testa på Facebook".`,
      howAreYouDoingToday: 'Hur mår du idag?',
      thisIsHowSimpleToUseFacebookBot: `Det är allt! Så här enkelt är det att använda en Facebook-bot`,
      letsCreateYourOwnChatFlowNow: `Nu ska vi skapa din egen chattflöde`,
    },
    instagramBot: {
      createNewBot: 'Skapa ny bot',
      back: 'Tillbaka',
      step: 'Steg ',
      of3: ' av 3',
      loginWithInstagram: 'Logga in med Instagram',
      loginToYourInstagramAccount:
        'Logga in på ditt Instagram-konto för att aktivera chattboten på ditt handtag.',
      managerLevelDescription:
        'Ägare till Instagram-boten måste ha minst behörighet "chef" eller högre för att få åtkomst till alla funktioner.',
      login: 'Logga in',
      connectInstagramBot: 'Anslut Instagram Bot',
      connectBotWithYourInstagramAnd: 'Anslut Bot med ditt Instagram och ',
      exploreTruePowerOfInstagram:
        'utforska den verkliga kraften hos Instagram',
      connected: 'Ansluten',
      connect: 'Anslut',
      createNewPage: 'Skapa ny sida',
      refreshPageList: 'Uppdatera sidolistan',
      thisPageIsSuccessfullyintegratedWith:
        'Denna sida är framgångsrikt integrerad med ',
      yourMessagesFromMessengerWillAppearIn:
        '. Dina meddelanden från Messenger kommer att visas i ',
      inbox: ' Inkorgen',
      continueToBotConfiguration: 'Fortsätt till Bot-konfiguration',
      welcomeToBrandNameWeAreHereToHelpYou: `Välkommen till ${brand}. Vi är här för att hjälpa dig.`,
      letsTryYourBotAndSeeHowItWorks: `Låt oss prova din bot och se hur den fungerar! Klicka på "Testa på Instagram".`,
      howAreYouDoingToday: 'Hur mår du idag?',
      thisIsHowSimpleToUseInstagramBot: `Det är allt! Så här enkelt är det att använda Instagram-bot`,
      letsCreateYourOwnChatFlowNow: `Nu ska vi skapa din egen chattflöde`,
    },
    telegramBot: {
      back: 'Tillbaka',
      step: 'Steg ',
      of3: ' av 3',
      seeHowToUse: 'Se hur du använder',
      help: 'Hjälp',
      loginToYourTelegramAccount: 'Logga in på ditt Telegram-konto',
      loginToYourAccountToCreateNewBotOrConnectExistingBot:
        'Logga in på ditt konto för att skapa en ny bot eller ansluta den befintliga',
      verificationCodeSentOnRegisteredNumber:
        'Verifikationskod skickad till det registrerade numret',
      createYourBot: 'Skapa din bot',
      enterYourBotsNameAnd: `Ange din bots namn, anslut och låt skojet börja med `,
      botUserNameMustEndWithBotAtTheEnd:
        'Botanvändarnamnet måste sluta med "bot" i slutet.',
      terrisBot: 'Exempelvis teris_bot eller terisbot',
      botNameAlreadyTaken: 'Detta botnamn är redan taget. Prova något annat',
      connect: 'Anslut',
      createBot: 'Skapa bot',
      codeNotReceivedResend: 'Har du inte fått koden? Skicka igen!',
      changeNumber: 'Byt nummer',
      telegramPreview: 'Telegram Förhandsvisning',
      worldsFastestMessagingApp: `Världens snabbaste meddelandeapp & Det är gratis!`,
      bot: 'Bot',
      phoneNumber: 'Telefonnummer',
      userName: 'Användarnamn',
      none: 'Ingen',
      bio: 'Bio',
      fewWordsAboutYourself: 'Några ord om dig själv',
      settings: 'Inställningar',
      notificationsAndSound: 'Aviseringar och ljud',
      privacyAndSecurity: 'Integritet och säkerhet',
      dataAndStorage: 'Data och lagring',
      chatSettings: 'Chattinställningar',
      chatFolders: 'Chattmappar',
      devices: 'Enheter',
      connectYourBot: 'Anslut din bot',
      createNewBotOrConnectWithExistingOne:
        'Skapa ny bot eller Anslut den befintliga',
      createNewBot: 'Skapa ny bot',
      welcomeToBrandNameWeAreHereToHelpYou: `Välkommen till ${brand}. Vi är här för att hjälpa dig.`,
      letsTryYourBotAndSeeHowItWorks: `Låt oss prova din bot och se hur den fungerar! Klicka på "Testa på Telegram".`,
      howAreYouDoingToday: 'Hur mår du idag?',
      thisIsHowSimpleToUseTelegramBot: `Det är allt! Så här enkelt är det att använda Telegram-bot`,
      letsCreateYourOwnChatFlowNow: `Nu ska vi skapa din egen chattflöde`,
      placeholders: {
        searchCountry: 'Sök land',
        enterTelegramMobileNumber: 'Ange Telegram mobilnummer',
        enterLoginCodeReceived:
          'Ange inloggningskod som mottagits på Telegram-kontot *',
        twoFactorAuthentication: '2FA-lösenord (valfritt)',
        botName: 'Botnamn *',
        botUserName: 'Botanvändarnamn *',
      },
    },
    websiteLandingPageLiveChatBot: {
      createNewBot: 'Skapa ny bot',
      seeHowToUse: 'Se hur du använder',
      help: 'Hjälp',
      back: 'Tillbaka',
      step: 'Steg ',
      of2: ' av 2',
      buildA: 'Bygg en ',
      thatMatchesYourBrandPersonality: ` som matchar din varumärkespersonlighet`,
      chatBotIcon: 'Chatbot-ikon ',
      optional: 'Valfri',
      themeColor: 'Temafärg',
      chatBotName: 'Chatbot-namn',
      botNameIsRequired: 'Botnamn krävs',
      botNameShouldBeLessThan50Characters:
        'Botnamn ska vara mindre än 50 tecken',
      continue: 'Fortsätt',
      welcomeToBrandNameWeAreHereToHelpYou: `Välkommen till ${brand}. Vi är här för att hjälpa dig.`,
      whatIsYourEmailAddress: 'Vad är din e-postadress?',
      invalidEmailAddress: 'Ogiltig e-postadress',
      customizeYourLandingPageBotLook: 'Anpassa din Landing Page Bot-look',
      customizeYourWidgetLook: 'Anpassa din widget-look',
      customizeYourBotLook: 'Anpassa din bot-look',
      buildYourLandingPageBotAndAutomateInteraction:
        'Bygg din Landningssidebot och automatisera interaktionen med dina kunder genom att dela dess länk',
      useLiveChatBotToConnectToCustomers:
        'Använd Live Chat Bot för att ansluta till dina kunder i realtid',
      connectChatBotToYourWebsiteAndAutomateInteractions:
        'Anslut ChatBot till din webbplats och automatisera interaktioner med besökare',
      widget: 'widget',
      botInterface: 'bot-gränssnitt',
      mergedBot: 'Webbplats Chatbot, Landningsside Bot, Mobilapp Chatbot',
      mergedBotToolTip:
        'Skapa en bot-sida för att fånga besökarnas uppmärksamhet och engagera dem i konversationer.',
      placeholders: {
        typeANameForYourBot: 'Skriv ett namn för din nya bot',
      },
      appTooltip: {
        TOOLTIP_WEBSITE_BOT_NAME: 'Ange ditt botnamn',
        mergedBotToolTip:
          'Skapa en bot-sida för att fånga besökarnas uppmärksamhet och engagera dem i konversationer.',
        TOOLTIP_WEBSITE_BOT_THEME_COLOR:
          'Välj en temafärg för ditt chattfönster',
        thisLogoWillBeUsedInTheBrandNamePlatformOnly: `Den här logotypen kommer endast att användas på ${
          brand ? brand : ''
        } -plattformen. Vi föreslår att du väljer din företagslogotyp. Lägg till en fyrkantig bild i PNG- eller JPG-format under 1 MB.`,
      },
    },
    whatsappBot: {
      back: 'Tillbaka',
      justAStepAway: 'Bara ett steg bort',
      seeHowToUse: 'Se hur du använder',
      help: 'Hjälp',
      createWhatsappChatBot: 'Skapa Chatbot',
      businessNameIsRequired: 'Företagsnamn krävs.',
      maximumLengthForBusinessName40Characters:
        'Maximal längd för företagsnamn är 40 tecken.',
      businessCategory: 'Företagskategori',
      categoryIsRequired: 'Kategori krävs.',
      descriptionIsRequired: 'Beskrivning krävs.',
      maximumLengthForDescription200Characters:
        'Maximal längd för beskrivning är 200 tecken.',
      pleaseFillAValidEmailAddress:
        'Var god fyll i en giltig företagse-postadress.',
      businessEmailIsRequired: 'Företagse-post krävs.',
      phoneNumberShouldHaveMinimum7Digits:
        'Telefonnummer bör ha minst 7 siffror',
      phoneNumberIsRequired: 'Telefonnummer krävs',
      websiteIsRequired: 'Webbplats krävs.',
      maximumLengthForWebsite40Characters:
        'Maximal längd för webbplats är 40 tecken.',
      maximumLengthForAddress150Characters:
        'Maximal längd för adress är 150 tecken.',
      doYouHaveWhatsappApiKey: 'Har du WhatsApp API-nyckel?',
      apiProvider: 'API-leverantör',
      three60Dialog: '360 Dialog',
      whatsappCloud: 'WhatsApp Cloud',
      netcore: 'Netcore',
      apiKeyIsRequired: 'API-nyckel krävs.',
      whatsappBusinessAccountIdIsRequired:
        'WhatsApp Business Account ID krävs.',
      whatsappPhoneNumberIdIsRequired: 'WhatsApp Phone Number ID krävs.',
      systemAccessTokenIsRequired: 'System Access Token krävs.',
      sourceIdIsRequired: 'Källa ID krävs.',
      businessName: 'Företagsnamn',
      businessAccount: 'Företagskonto',
      businessDescription: 'Företagsbeskrivning',
      address: 'Adress',
      businessEmail: 'Företagse-post',
      websiteUrl: 'Webbplats-URL',
      thankYouForYourInterestIn: 'Tack för ditt intresse för ',
      whatsappChatBot: ' WhatsApp Chatbot.',
      weHaveReceivedYourInterests:
        'Vi har mottagit ditt intresse, och vårt försäljningsteam kommer att kontakta dig inom de närmaste 24 timmarna.',
      theyWillProvideYouWhatsappApiKey:
        'De kommer att ge dig WhatsApp API-nyckeln.',
      readyToCreateWhatsappBot: `Jag är redo att skapa WhatsApp Bot`,
      exploreWhatsappFeatures: 'Utforska WhatsApp-funktioner',
      welcomeToBrandNameWeAreHereToHelpYou: `Välkommen till ${brand}. Vi är här för att hjälpa dig.`,
      letsTryYourBotAndSeeHowItWorks: `Låt oss prova din bot och se hur den fungerar! Klicka på "Testa på WhatsApp".`,
      howAreYouDoingToday: 'Hur mår du idag?',
      thisIsHowSimpleToUseWhatsappBot: `Det är så enkelt! Så här enkelt är det att använda WhatsApp-bot`,
      letsCreateYourOwnChatFlowNow: `Låt oss skapa din egen chattflöde nu`,
      connectWhatsAppBot: 'Anslut WhatsApp Bot',
      createtWhatsAppBot: 'Fyll i dina företagsuppgifter',
      proceed: 'Fortsätt',
      whatsApiProvider: 'WhatsApp API-leverantör',
      cloudApi: 'Cloud API',
      netcoreApi: 'Netcore API',
      loginWithFacebook: 'Logga in med Facebook för WhatsApp Onboarding',
      asPerLatestChangesInFacebook:
        'Enligt de senaste ändringarna i Facebooks policys måste ägaren av Facebook-boten ha rollen som admin för att få tillgång till alla funktioner på Facebook-sidan.',
      login: 'Logga in',
      successWhatsAppOnboarding: 'Framgång! WhatsApp-kontot är godkänt!',
      congratulationYourWhatsApp:
        'Grattis, ditt WhatsApp-nummer har godkänts. Uppdatera din betalningsmetod för att börja använda din bot.',
      sendFirstMessage: 'Skicka första meddelandet',
      editYourChatFlow: 'Redigera ditt chattflöde',
      overview: 'Översikt',
      oopsErrorOccurred: 'Hoppsan! Ett fel inträffade under Onboarding',
      oopsSomethingWentWrong:
        'Hoppsan! Något gick fel under onboarding-processen. Granska din information och försök igen. Om problemet kvarstår, kontakta vårt supportteam för hjälp.',
      setupManually: 'Konfigurera manuellt',
      retryWithAutomatedOnboarding: 'Försök igen med automatisk onboarding',
      placeholders: {
        yourBusinessName: 'Ditt företagsnamn',
        businessDescription: 'Företagsbeskrivning',
        businessEmail: 'Företagse-post',
        phone: 'Telefon*',
        website: 'Webbplats (t.ex. www.example.com)',
        address: 'Adress',
        enterApiKey: 'Ange API-nyckel',
        enterWhatsappBusinessAccountId: 'Ange WhatsApp Business Account ID',
        enterWhatsappPhoneNumberId: 'Ange WhatsApp Phone Number ID',
        enterSystemAccessToken: 'Ange System Access Token',
        enterSourceId: 'Ange Source ID',
        businessName: 'Företagsnamn',
        businessWebsite: 'Företagswebbplats',
        selectWhatsappApiProvider: 'Välj WA API-leverantör',
      },
      stepFour: {
        chooseYourWhatsAppAPIProvider: 'Välj din WA API-leverantör',
        doYouHaveWhatsAppBusinessAPI: 'Har du WhatsApp Business API?',
        yes: 'Ja',
        noIAmNotSure: 'Nej, jag är inte säker',
        selectApiProvider: 'Välj API-leverantör',
        whatsAppCloudAPI: 'WhatsApp Cloud API',
        enterYourPhoneNumberId: 'Ange ditt telefonnummer ID',
        phoneNumberId: 'Telefonnummer ID',
        enterYourWhatsAppBusinessAccountId:
          'Ange ditt WhatsApp Business Account ID',
        whatsAppBusinessAccountId: 'WhatsApp Business Account ID',
        enterYourSystemUserToken: 'Ange ditt System User Token',
        systemUserToken: 'System User Token',
        help: 'Hjälp',
        netcoreAPI: 'Netcore API',
        enterYourSourceId: 'Ange din Source ID',
        sourceId: 'Source ID',
        enterYourNetcoreApiKey: 'Ange din Netcore API-nyckel',
        netcoreApiKey: 'Netcore API-nyckel',
        submit: 'Skicka',
        noneOftheAbove: 'Ingen av ovanstående',
        next: 'Nästa',
      },
      stepTwo: {
        legallyRegisteredBusiness: 'Juridiskt registrerat företag',
        validWebsiteWithDataPrivacyPolicy:
          'Giltig webbplats med dataskyddspolicy',
        debit: 'Debet',
        creditCard: 'Kreditkort',
        gstin: 'GSTIN',
        onlyRequiredForIndianResidents:
          'Endast nödvändigt för indiska invånare',
        onlyRequiredFor: 'Endast nödvändigt för',
        indianResidents: 'indiska invånare',
        validPaymentMethod: 'Giltig betalningsmetod',
        enabledWithInternationalPayments:
          'aktiverad med internationella betalningar',
        validUseCaseInComplianceWithWhatsAppCommercePolicy:
          'Giltigt användningsfall i enlighet med WhatsApp Commerce Policy',
        PhoneNumberWhichDoesNotHaveActiveWhatsAppAndCapableOfReceivingTheSMS:
          'Telefonnummer som inte har aktiv WhatsApp och kan ta emot SMS',
        discard: 'Kasta bort',
        proceed: 'Fortsätt',
        whatsAppBotPrerequisites: 'Förutsättningar för WhatsApp Bot',
        letUsGetItDoneForYou: 'Låt oss fixa det åt dig!',
        ifYouAreFacingSomeIssues: 'Om du stöter på några problem',
        ourTeamCanHelpYouDoTheSame: 'Vårt team kan hjälpa dig med samma sak',
        requestACallbackNow: 'Begär en återuppringning nu!',
      },
      stepThree: {
        setupWhatsAppBot: 'Konfigurera WhatsApp Bot',
        selectingTheBestBusinessManagerForYourNeeds:
          'Välj den bästa affärschefen för dina behov',
        createMetaApp: 'Så här skapar du Meta App',
        createaMetaAppOn: 'Skapa en Meta App på',
        howToCreate: 'Hur man skapar',
        addWhatsAppNumber: 'Så här lägger du till WhatsApp-numret',
        addYourWhatsAppNumberAndVerifyTheSame:
          'Lägg till ditt WhatsApp-nummer och verifiera det samma',
        subscribe: 'Prenumerera',
        copyAndSubscribeWebhook: 'Kopiera och prenumerera på Webhook',
        howToSubscribe: 'Hur man prenumererar',
        copy: 'Kopiera',
        appSecretId: 'App Secret ID',
        enterYourAppSecretId: 'Ange ditt App Secret ID',
        enterAppSecret: 'Ange App Secret',
        phoneNumberId: 'Telefonnummer ID',
        whatsAppBusinessId: 'WhatsApp Business ID',
        assignSystemUser: 'Så här tilldelar du Systemanvändare',
        assign: 'Tilldela',
        createApp: 'Skapa Meta',
        registerAndVerify: 'Registrera & verifiera',
        add: 'Lägg till',
        systemUserToken: 'Systemanvändar-token',
        enterYourSystemUserToken: 'Ange ditt Systemanvändar-token',
        getAllNecessaryDetails: 'Så här får du alla nödvändiga detaljer',
        subscribeWhatsAppWebhook: 'Hur man prenumererar på WA Webhook',
        configureTheWebhookForWhatsAppAccount:
          'Konfigurera Webhook för WhatsApp-konto',
        upadatePaymentMethod: 'Så här uppdaterar du betalningsmetoden',
        assignThePaymentMethodToWhatsAppAccount:
          'Tilldela betalningsmetoden till ett WhatsApp-konto',
        grantControlOfWhatsAppBusinessAccountToASystemUser:
          'Ge kontroll över ett WhatsApp Business Account till en systemanvändare',
        keyDetailsThatYouNeedToCopyFromMetaDashboard:
          'Viktiga detaljer som du behöver kopiera från Meta Dashboard',
        updatePayment: 'Uppdatera betalning',
        letUsGetItDoneForYou: 'Låt oss fixa det åt dig!',
        ifYouAreFacingSomeIssues: 'Om du stöter på några problem',
        ourTeamCanHelpYouDoTheSame: 'Vårt team kan hjälpa dig med samma sak',
        requestACallbackNow: 'Begär en återuppringning nu!',
        update: 'Uppdatera',
        connectNow: 'Anslut nu',
      },
      stepFive: {
        selectBusinessManager: 'Välj affärschef',
        selectingTheBestBusinessManagerForYourNeeds:
          'Välj den bästa affärschefen för dina behov',
      },
      stepSix: {
        yourBotIsInstalledAndActive: 'Din bot är installerad och aktiv',
        youhaveSuccessfullyConnected: 'Du har framgångsrikt anslutit',
        withWhatsApp: 'med WhatsApp',
        youHaveBeenAllocaated100ConversationsPerMonthByDefault:
          'Du har tilldelats 100 konversationer per månad som standard',
        upgradeYourPlanForMore: 'Uppgradera din plan för mer.',
        createChatFlow: 'Skapa chattflöde',
        upgradePlan: 'Uppgradera plan',
      },
      activeDemoBotStepFive: {
        scanQrOrSendMessageToActivateBot:
          'Skanna QR eller skicka meddelande för att aktivera bot',
        scanTheQrCodeFrom: 'Skanna QR-koden från',
        yourPhoneWillOpen:
          'Din telefon kommer att öppna ett förifyllt meddelande att skicka till vårt sandbox-nummer. Tryck på "Skicka" på WhatsApp',
        sendMessageFromYourWhatsAppNumber:
          'Skicka meddelande från ditt WhatsApp-nummer',
        sendUsAWhatsAppMessageOn: 'Skicka oss ett WhatsApp-meddelande på ',
        bySavingInYourContactsAndMessageShouldStartwith:
          ' genom att spara i dina kontakter och meddelandet ska börja med ',
        send: 'Skicka',
        or: 'ELLER',
      },
      phoneNumberSetup: {
        waPhoneNoSetup: 'WhatsApp-telefonnummerinställning',
        loginWithFb: 'Logga in med Facebook för inbäddad WhatsApp Onboarding',
        continueWithFb: 'Fortsätt med Facebook',
        connectAPIKey: 'Anslut med API-nyckel',
        apiKeyContinue:
          'Om du redan har det verifierade numret och API-nyckeln, följ sedan nedan steg för att fortsätta installationen',
        connectWaNo: 'Anslut WhatsApp-nummer',
      },
    },
  },
  gettingStarted: {
    hello: 'Hej, ',
    upgrade: 'Uppgradering',
    gettingStarted: 'Kom igång - ',
    yourFacebookBotToken: 'Din Facebook-bot-token ',
    hasBeenExpired: 'har löpt ut',
    isExpiringIn: 'löper ut om ',
    days: ' dagar',
    facebookAuthenticationTokenRemainsFor60Days:
      'Facebook-autentiseringstoken är aktivt endast i 60 dagar',
    kindlyProceedWithTheRenewalOfYourBotToken:
      'Vänligen fortsätt med förnyelsen av din bot-token för att säkerställa oavbruten åtkomst till chatbot-tjänster.',
    renewYourBotToken: 'Förnya din bot-token',
    editYourChatFlow: 'Redigera ditt chattflöde',
    buildConversationEngagingBot:
      'Bygg engagerande konversationsflöden för dina botanvändare.',
    takes5minutes: 'tar 5 minuter',
    previewYourLiveChatWidget: 'Förhandsgranska din Live Chat-widget',
    discoverHowThe: 'Upptäck hur ',
    liveChatFeatureWorks:
      ' Live Chat-funktionen fungerar med vår Live Chat-lekplats',
    takes2minutes: 'tar 2 minuter',
    takes1minute: 'tar 1 minut',
    connected: 'Ansluten',
    customizeYourBotApperance: `Anpassa din bots utseende och funktionalitet.`,
    takes3minutes: 'tar 3 minuter',
    thirdPartyAppsIntegration: 'Integration med tredjepartsappar',
    integrateYourBot:
      'Integrera din bot med andra appar/CRM för att skapa affärsautomatisering.',
    upgradeYourPlanToReceiveLeadsInEmail:
      'Uppgradera din plan för att ta emot leads via e-post',
    getStartedWithUs: 'Kom igång med oss',
    howToBuildAGoodChatFlow: 'Hur man bygger ett bra chatflow',
    howToUseBotPenguinsInboxAndItsFeatures: `Hur man använder BotPenguins Inkorg och dess funktioner`,
    botPenguinsPricing: `BotPenguins Prissättning: Utforska planer och funktioner`,
    openHelpDesk: 'Öppna hjälpdesk',
    helpAndSupport: 'Hjälp och support',
    extensiveGuides:
      'Omfattande guider för alla dina frågor och arbetsflöden finns tillgängliga i vår ',
    resourceCentre: 'Resurscenter',
    checkoutOurAnswers: 'Du kan kolla in våra svar på vanliga frågor nedan.',
    createANewBot: 'Skapa en ny bot',
    installYourBot: 'Installera din bot',
    plansAndPricing: 'Planer och prissättning',
    previewYourLandingPageBot: ' Förhandsgranska din Landing Page-bot',
    installYourLiveChatWidget: 'Installera din Live Chat-widget',
    installYourWebsiteBot:
      'Installera din chatbot på webbplatsen, mobilappen eller starta som landningssida eller inbäddad chatbot',
    integrateBotToLandingPage: 'Integrera boten med din landningssida',
    installWidgetToWebsite: 'Installera widgeten på din webbplats',
    installBotToWebsite: 'Installera din chatbot',
    whatsappAutomation: 'WhatsApp-automatisering',
    facebookAutomation: 'Facebook-automatisering',
    telegramBotSettings: 'Inställningar för Telegram Bot',
    liveChatWidgetSettings: 'Inställningar för Live Chat Widget',
    landingPageBotSettings: 'Inställningar för Landningssida Bot',
    websiteChatBotSettings: 'Inställningar för webbplatschatbot',
    instagramAutomation: 'Instagram-automatisering',
    diveDeeperIntoBotPenguin: 'Dyk djupare in i BotPenguin',
    knowWhereWeAreGoing:
      'Vet vart vi går, de senaste uppdateringarna och hjälp oss fixa några buggar.',
    productUpdates: 'Produktuppdateringar',
    requestAFeature: 'Begär en funktion',
    reportABug: 'Rapportera en bugg',
    prodcutRoadmap: 'Produktplan',
    trainYourChatbot: 'Träna din AI Chatbot (kunskapsbas)',
    buildEngagingConversation:
      'Bygg engagerande konversationsflöden för dina botanvändare.',
    previewYourAIBot: 'Förhandsgranska din AI-bot',
    integrateAIbot: 'Integrera boten med din AI-bot',
    aiBotSettings: 'Inställningar för AI Bot',
    CustomizeAIBot: 'Anpassa din bots utseende och funktionalitet.',
    gptKeyWarning:
      'Observera: Du kan använda upp till 100 GPT-meddelanden per bot. För att fortsätta använda utöver den angivna gränsen, vänligen anslut din egen ChatGPT API-nyckel under ChatGPT Model Configuration.',
    whatsappBotSettings: 'Inställningar för WhatsApp Bot',
    automateCustomerEngagementWithWhatsApp:
      'Automatisera kundengagemang med WhatsApp.',
    connectToYourWhatsappNumber: 'Anslut till ditt WhatsApp-nummer',
    connectYourWhatsappBotWithYourWhatsappNumber:
      'Anslut din WhatsApp-bot med ditt WhatsApp-nummer',
    facebookBotSettings: 'Inställningar för Facebook Bot',
    automateCustomerEngagementWithTelegram:
      'Automatisera kundengagemang med Telegram',
    automateCustomerEngagementWithFacebook:
      'Automatisera kundengagemang med Facebook',
    automateCustomerEngagementWithInstagram:
      'Automatisera kundengagemang med Instagram',
    telegramAutomation: 'Telegram Automation',
    limitExhaustMessage: 'Du har nått den maximala gränsen för gratis 100 API-meddelanden för ditt konto. Klicka på knappen \'Lägg till API-nyckel\' för att ange din ChatGPT API-nyckel och fortsätta använda vår ChatGPT API-tjänst.',
    addApiKey: 'Lägg till API-nyckel',
  },
  install: {
    previewYourLandingPageBot: 'Förhandsgranska din Landing Page-bot',
    preview: 'Förhandsgranska',
    test: 'Testa',
    squareSpace: 'Squarespace',
    installYourChatBot: 'Installera din chattbot',
    seeHowToUse: 'Se hur du använder den',
    help: 'Hjälp',
    uniqueLinkToLandingPageBot:
      'Här är den unika länken till din landningssida-bot.',
    shareOnSocialMedia:
      'Dela den enkelt med dina användare på sociala medier, kontaktsidor eller visitkort.',
    or: 'ELLER',
    copyUrl: 'Kopiera URL',
    selectYourWebsiteCms: 'Välj din webbplats-CMS',
    selectCms: 'Välj CMS/Builder som du har använt för att skapa din webbplats',
    custom: 'Anpassad',
    wordpress: 'Wordpress',
    shopify: 'Shopify',
    wix: 'Wix',
    zoomla: 'Zoomla',
    otherCms: 'Annan CMS',
    howWouldYouLikeToInstall: 'Hur vill du installera den?',
    installingWebsiteBot:
      'Välj hur du kommer att installera boten på din webbplats',
    iWillAddMyself: 'Jag kommer lägga till den själv',
    getChatBotScript: 'Få chattbotskriptkoden nedan och installera allt själv',
    getWordpressPlugin: 'Få WordPress-plugin-API-nyckel',
    getOurOfficialPlugin: 'Få vårt officiella plugin ',
    fromWordpressPluginStore: ' från WordPress-plugin Store',
    getPlugin: 'Hämta plugin',
    quickGuideToInstall: 'Snabbguide för installation',
    placeApiKeyBelowIn: 'Klistra in API-nyckeln nedan i ',
    afterDownloadingAndActivatingPlugin:
      ' efter att ha laddat ner och aktiverat plugin',
    copy: 'Kopiera',
    enterYourWebsite:
      'Ange din webbplats och låt oss se hur din chattbot ser ut',
    enterAValidUrl: 'Ange en giltig URL',
    verifyYourInstallation:
      'Verifiera om din installation är lyckad eller inte?',
    testInstallation: 'Testa installationen',
    getChatBotScriptCode: 'Hämta chattbotskriptkod',
    copyThisCodeSnippet:
      'Kopiera denna kodsnutt och klistra in den i HTML på varje webbsida där du vill visa chattboten eller klistra in den i sidfoten innan taggen stängs för att visas på varje sida.',
    sendCodeToMyDeveloper: 'Skicka kod till min utvecklare',
    sendCodeToMyDevelopmentTeam: 'Skicka kod till mitt utvecklingsteam',
    sendEmail: 'Skicka e-post',
    enterAValidEmail: 'Ange en giltig e-postadress',
    codeHasBeen: 'Koden har blivit ',
    toYourDeveloper: ' till din utvecklare ',
    resent: 'skickad igen',
    sent: 'skickad',
    resendEmail: 'Skicka e-post igen',
    ask: 'Fråga ',
    supportTeamToInstall: ' Support Team för att installera',
    raiseTheInstallationRequestTo: 'Höj installationsbegäran till ',
    team: ' Team',
    helpMeInstallingChatBot: 'Hjälp mig att installera ChatBot',
    yourBotInstallationIsNotActive: 'Din botinstallation är inte aktiv!',
    monthlyMessageLimitExceeded: 'Månadsvis meddelandelimit överskriden',
    exceededMonthlyMessageLimitUpgradeNow:
      'Du har överskridit din månatliga meddelandelimit, Uppgradera nu.',
    upgradeNow: 'Uppgradera nu',
    botInstallationNotActivePleaseFix:
      'Din botinstallation är inte aktiv, Var vänlig fixa detta. ',
    incorrectBotScript: 'Felaktig Bot-skript',
    installationCodeYouAreVerfiyingNotMatchingOnYourSite: `Den installationskod du verifierar matchar inte den på din webbplats.
      Var vänlig se till att du har installerat rätt kod för denna bot.`,
    unableToSee: 'Kan inte se ',
    codeOnYourWebsite: ' kod på din webbplats',
    unableToFindCodePleaseReinstall:
      'Vi kan inte hitta koden på din webbplats, Var vänlig installera om.',
    reinstallBot: 'Installera om boten',
    yourBotIsInstalledAndActive: 'Din bot är installerad och aktiv!',
    noPendingAction: 'Ingen väntande åtgärd, Din bot är installerad och aktiv',
    youAreAllSet: 'Du är redo!',
    showMeMyLeads: 'Visa mig mina leads',
    connectingToYourWebsiteToVerifyInstallation:
      'Ansluter till din webbplats för att verifiera botinstallation',
    thisMayTakeUpto30Seconds: 'Detta kan ta upp till 30 sekunder',
    hereIsTheuniqueAILink: 'Här är den unika länken till din AI-bot',
    installHeading: 'Installera din Chattbot',
    websiteChatbot: 'Webbplats Chattbot',
    aiChatBot: 'AI Chattbot',
    landingPageBot: 'Landningssida Bot',
    mobileChatBot: 'Mobil App Chattbot',
    embeddedBot: 'Inbäddad Chattbot',
    selectMobileDevice: 'Välj din mobila enhet',
    mobileDeviceSubheading:
      'Välj det nativa språket du har använt för att skapa din mobilapp',
    ios: 'IOS',
    android: 'Android',
    reactNative: 'React Native',
    otherMobileDevice: 'Annan',
    copyEmbeddedCodeSnippet:
      'Kopiera denna kodsnutt och klistra in den i HTML på varje webbsida där du vill visa chattboten.',
    copyMobileCodeSnippet:
      'Kopiera denna kodsnutt i din mobilapplikationskod där du vill visa chattboten.',
    placeholders: {
      exampleSite: 'https://www.dinsajt.com',
      enterDeveloperEmail: 'Ange utvecklar-e-post',
    },
    installGeneral: {
      sendInstructionsToYourDeveloper:
        'Skicka instruktioner till din utvecklare',
      notSureHowToDoIt:
        'Inte säker på hur man gör? Dina utvecklare kan göra det på ett kick.',
      developersEmail: 'Utvecklarens e-post',
      emailIsRequired: 'E-post krävs',
      subject: 'Ämne',
      message: 'Meddelande',
      send: 'Skicka',
      placeholders: {
        enterYourWorkEmail: 'Ange din arbets-e-post',
        createBotUsingBotPenguin: 'Spännande! Skapa en bot med BotPenguin',
      },
    },
    platforms: {
      hereIsUniqueLinkToLandingPageBot:
        'Här är den unika länken till din Landningssida Bot.',
      shareWithUsersOnSocialMedia:
        'Dela den enkelt med dina användare på sociala medier, kontaktsidor eller visitkort.',
      previewMyLandingPageBot: 'Förhandsgranska min Landningssida Bot',
      or: 'ELLER',
      copyUrl: 'Kopiera URL',
      howYouLikeToAddBot:
        'Välj hur du vill lägga till din Bot-kod på din webbplats',
      installTheBotToYourCustomCodedOrWordPressWebsite:
        'Installera Bot till din anpassade kodade eller WordPress-webbplats genom att kopiera och klistra in en unik kod.',
      name: 'Namn',
      actions: 'Åtgärder',
      javascript: 'Javascript',
      install: 'Installera ',
      onYourCustomCodedWebsite: ' på din anpassade kodade webbplats',
      copyAndPaste: 'Kopiera och klistra in',
      copyThisCodeSnippet:
        'Kopiera denna kodsnutt och klistra in den i HTML på varje webbsida' +
        ' där du vill visa widgeten. För mer detaljer',
      seeGuide: 'se guide',
      getCode: 'Hämta kod',
      howToInstall: 'Hur man installerar?',
      copyCode: 'Kopiera kod',
      wordpress: 'Wordpress',
      // install: 'Installera ',
      onYourWordPressWebiste: ' på din WordPress-webbplats',
      preview: 'Förhandsgranska',
      test: 'Testa',
    },
  },
  liveChatPreview: {
    liveChatPreview: 'Förhandsgranska Live Chat',
    agentWindow: 'Agentfönster',
    person: 'person',
    inOrderToTestTypeHere: 'För att testa, skriv här',
    agentWindowCannotBeCustomized: 'Observera: Agentfönstret kan inte anpassas',
    customerWindow: 'Kundfönster',
    clickHereToChat: 'Klicka här för att chatta',
    customerWillChatHere: 'Kunden kommer att chatta här',
    chat: 'Chatta',
    by: 'av',
    changeYourBotLookFromLeftPanel:
      'Ändra din bots utseende från vänsterpanelen',
    placeholders: {
      typeYourMessage: 'Skriv ditt meddelande...',
      typeYourAnswer: 'Skriv ditt svar',
    },
  },
  previews: {
    previewYourLiveChatWidget: 'Förhandsgranska din Live Chat Widget',
    install: 'Installera',
    seeHowToUse: 'Se hur man använder den',
    appTooltip: {
      clickToInstallYourBotToSelectedPlatform:
        'Klicka för att installera din bot på den valda plattformen',
    },
  },
  trainYourBot: {
    trainYourBot: 'Träna din AI Chattbot',
    knowledgeBase: 'Kunskapsbas',
    faqs: 'FAQ',
    history: 'Historia',
    faqHeading: 'Vanliga frågor',
    faqSubHeading:
      'Träna din chattbot på vanliga frågor för att ge korrekta svar.',
    knowledgeBaseHeading: 'Träna din chattbot',
    knowledgeBaseSubheading:
      'Träna din chattbot för förbättrade konversationer',
    websiteLink: 'Webbplatslänk',
    uploadFile: 'Ladda upp din fil',
    selectFile: 'Välj fil',
    submit: 'Skicka in',
    searchHere: 'Sök här',
    question: 'Fråga',
    answer: 'Svar',
    questionPlaceholder: 'Skriv din fråga här',
    answerPlaceholder: 'Skriv ditt svar här',
    save: 'Spara',
    discard: 'Kasta',
    addFaq: 'Lägg till FAQ',
    createdAt: 'Skapad den',
    updatedAt: 'Senast uppdaterad den',
    actions: 'Åtgärder',
    noFaqFound: 'Du har inte skapat några FAQ ännu',
    noFaqFoundMessage: 'Alla dina FAQ kommer att visas här',
    historyTitle: 'Historik över kunskapsbasen',
    historySubtitle: 'Svar på dina frågor om träning av chattbot',
    fileName: 'Filnamn',
    status: 'Status',
    noHistoryTitle: 'Du har inte skapat några tränade modeller ännu',
    noHistoryDescription: 'Alla dina tränade modeller kommer att visas här',
    fileUpload: 'Filuppladdning',
    files: 'Filer',
    fileSubHeading: 'Ladda upp alla filer för att träna din AI-chattbot.',
    noFileFoundHeading: 'Du har inte laddat upp några filer ännu.',
    noFileFoundSubheading: 'Alla dina filer kommer att visas här',
    uploadYourFiles: 'Ladda upp dina filer',
    upload: 'Ladda upp',
    fileShouldBe: 'Fil bör vara PDF, DOC, DOCX, PPTX, TXT.',
    uploadStatus: 'Uppladdningsstatus',
    uploadStatusSubHeading: 'Status för filuppladdning för botträning',
    addFile: 'Lägg till fil',
    otherConfiguration: 'AI-inställningar',
    deleteFiles: 'Klicka för att ta bort filer',
    websiteURL: 'Webbplats-URL: er',
    websiteUrlSubheading:
      'Lägg till webbplats-URL: er för att träna din AI-chattbot.',
    enterWebsiteUrl: 'Ange URL',
    addWebsite: 'Lägg till webbplats',
    tableWebsiteUrl: 'Webbplats-URL',
    trainingStatus: 'Träningsstatus',
    lastTrained: 'Senast tränad',
    noWebsitesFound: 'Inga hämtade webbplatser ännu!',
    noWebsitesFoundMessage: 'Alla dina webbplatser kommer att visas här',
    loadMore: 'Ladda mer',
    botBehaviour: 'Konfigurera botbeteende',
    botBehaviourSubHeading:
      'Konfigurera botens personlighet, redigera kunddata, hantera flöde och ChatGPT-modell',
    botPersonality: 'Konfigurera botens personlighet',
    botPersonalitySubHeading:
      'Hantera hur din bot ska svara i fråga om personlighet',
    selectAnswerLength: 'Välj svarslängd',
    answerLength: 'Svarslängd',
    answerAs: 'Svara som',
    tone: 'Ton',
    language: 'Språk',
    answerFormatting: 'Svarsformatering',
    customInstructions: 'Anpassad uppmaning',
    customerInstructionPlaceholder:
      'Var artig och vänlig. Använd inte slang. Använd inte emojis',
    redactCustomerData: 'Samla in kunddata',
    redactDataSubheading: 'Konfigurera den kundinformation du vill samla in',
    collectName: 'Samla in namn',
    configureQuestion: 'Konfigurera fråga',
    maxCharacterLimit: 'Maximal teckenbegränsning i det angivna namnet',
    collectEmail: 'Samla in e-post',
    excludeEmail: 'Uteslut e-postmeddelanden med domän',
    collectPhone: 'Samla in telefon',
    manageUnusualMessages: 'Hantera ovanliga chattscenarier',
    unusualMessagesSubheading:
      'Hantera obesvarade och andra sällsynta scenarier för boten',
    startConversation: 'Meddelande för att starta konversation',
    configureMessage: 'Meddelande när boten inte kan svara',
    profanityMessage:
      'Meddelande för att svara på användning av olämpligt språk',
    chatGptModel: 'Konfiguration av ChatGPT-modell',
    chatGptModelSubheading:
      'Hantera vilken ChatGPT-modell som ska användas och undvik missbruk',
    chatGptApi: 'ChatGPT API-nyckel',
    enableDisableRedactData: 'Samla in kunddata',
    triggerToCollectData:
      'Samla kontaktinformation efter en uppsättning frågor.',
    train: 'Träna',
    website: 'Webbplats',
    analytics: 'Analys',
    conversationsHistory: 'Konversationens historia',
    exportCustomerConversation:
      'Exportera kundkonversationer för AI-chattbot-träning.',
    includedSourcesForResponse: 'Inkluderade källor för svar',
    visibility: 'Synlighet',
    yourConversation: 'Dina konversationer',
    reviewAndSelectConversation:
      'Granska och välj konversationer att exportera för chattbot-träning',
    exportAiAnalytics: 'Exportera analyser',
    startDate: 'Startdatum',
    endDate: 'Slutdatum',
    userQuestion: 'Användarens fråga',
    botsReply: 'Botens svar',
    dateCreated: 'Datum skapad',
    noAnalyticsFound: 'Det finns inga konversationer att visa.',
    noAnalyticsFoundMessage: 'Alla dina botinteraktioner kommer att visas här.',
    detectYourLanguage:
      'Identifiera användarnas språk och svara på samma språk',
    exportData: 'Exportera data',
    exportCompleteAnalyticsData: 'Exportera komplett analysdata',
    export: 'Exportera',
    integrateWithChatGpt: 'Integrera med ChatGPT',
    integrated: 'Integrerad',
    connected: 'Ansluten',
    gpt3: 'GPT-3.5 (Lägre kostnad, Genomsnittlig noggrannhet)',
    gpt4: 'GPT-4 (Högre kostnad, Högre noggrannhet)',
    gptAssistant: 'Assistenter Beta* (Premiumkostnad, överlägsen noggrannhet)',
    configure: 'Konfigurera',
    prompt: 'Prompt',
    vectorResult: 'Vektorresultat',
    personalizeReplies: 'Individualisera svar med chatt historik',
    personalizeRepliesNote:
      'Observera: Att aktivera den här funktionen ökar tokenstorleken och påverkar kostnaden för ChatGPT-exekvering.',
    appToolTip: {
      deleteWebsite: 'Ta bort webbplats',
      knowledgeBase: 'Träna din bot med kunskapsbas',
      faqs: 'Träna din bot med vanliga frågor',
      knowledgeHistory: 'Historik över kunskapsbasen',
      uploadFaqs: 'Ladda upp vanliga frågor',
      addFaqs:
        'Klicka för att lägga till vanliga frågor för träning av din AI-chattbot',
      deleteFaqs: 'Ta bort vanliga frågor',
      deleteHistory: 'Ta bort historik',
      uploadFile:
        'Den uppladdade filen måste vara pdf, docx, doc eller csv och storleken bör vara högst 1 MB.',
      trainWebsite: 'Träna din bot med en webbplats.',
      fileUpload:
        'Träna din bot genom att använda filer som PDF: er, TXT: er, PPTX: er, DOC: er och DOCX: er.',
      configureBotBehaviour:
        'Anpassa botens personlighet, hantera flöde och justera ChatGPT-modellen.',
      clickToAddWebsite:
        'Klicka för att lägga till webbplats-URL: er för träning av din AI-chattbot.',
      clickToAddFile:
        'Klicka för att ladda upp alla filer för träning av din AI-chattbot',
      clickToDeleteWebsites: 'Klicka för att ta bort webbplatser',
      syncWebsite: 'Synkronisera webbplats',
      copyUrl: 'Kopiera URL',
      weWillBeFetchingAllTheWebpages:
        'Vi kommer att hämta alla webbsidor och träna ChatGPT-modellen på dem.',
    },
    modal: {
      deleteWebsiteUrl: 'Ta bort webbplats-URL',
      areYouSureYouWantToDeleteThisWebsiteUrl:
        'Är du säker på att du vill ta bort denna webbplats-URL?',
    },
  },
  configuration: {
    websiteChatbotSetting: 'Inställningar för webbplatsens chatbot',
    preview: 'Förhandsgranska',
    test: 'Testa',
    install: 'Installera',
    designHeader: 'Design',
    generalHeader: 'Allmänt',
    alertsHeader: 'Aviseringar',
    triggerHeader: 'Utlösare',
    userAccessHeader: 'Användaråtkomst',
    chatWindowHeader: 'Chattfönster',
    otherConfiguration: 'AI-inställningar',
    appTooltip: {
      clickToInstallYourBotToSelectedPlatform:
        'Klicka för att installera din bot på den valda plattformen',
      customizeAppearanceOfBot:
        'Anpassa positioneringen och utseendet på din bot-gränssnitt.',
      configureBotsSettingsWhenAgentUnavailable: `Konfigurera botens inställningar när din agent inte är tillgänglig.`,
      configureHowBotWillAlertYou:
        'Konfigurera hur din bot kommer att meddela dig om nya leads.',
      makeSureYourBotsPopUpProperlyTimed: `Se till att din bots pop-ups är perfekt tajmade.`,
      customizeWhereYouWantYourBotToAppear:
        'Anpassa var du vill att din bot ska visas och var inte.',
      enableChatOptionsForVisitorsToTransferChat:
        'Aktivera chattalternativ för dina besökare att överföra chattar, live-chatt och uppdatera chatt.',
      configureBotBehaviour:
        'Anpassa botens personlighet, hantera flödet och justera ChatGPT-modellen.',
    },
    alerts: {
      configureYourBotsAlertSettings: `Konfigurera dina bots avisinställningar`,
      specifyHowYourBotWillNotify:
        'Ange hur din bot kommer att meddela dig om nya leads.',
      subject: 'Ämne',
      emailNotification: 'E-postavisering',
      emailAddresses: 'E-postadresser',
      leadRevisitNotification: 'Lead Revisit Aviseringar',
      youHaveSuccessfullyRegisteredWithDesktopNotifications:
        'Du har framgångsrikt registrerat dig med skrivbordsaviseringar',
      youHaveBlockedYourNotificationsOnBrowser:
        'Du har blockerat aviseringar i din webbläsarinställningar.',
      discard: 'Förkasta',
      saveChanges: 'Spara ändringar',
      seeHowToUse: 'Se hur du använder',
      placeholders: {
        enterSubjectForYourEmail: 'Ange ämnet för din e-post',
        typeYourEmailAddressAndHitEnter:
          'Skriv in din e-postadress och tryck på Enter',
      },
      appTooltip: {
        TOOLTIP_SUBJECTS:
          'Anpassa ämnet för dina e-postaviseringar från botten',
        TOOLTIP_EMAIL_NOTIFICATION:
          'Aktivera/inaktivera bottennotifiering på din e-post för nya leads',
        TOOLTIP_EMAIL_ADDRESS:
          'Skicka e-postadressen för kontot där du vill ta emot e-postaviseringar. Du kan lägga till flera e-postadresser genom att ange en och trycka på Enter för att lägga till en annan.',
        TOOLTIP_LEAD_REVISIT_NOTIFICATION:
          ' Aktivera/inaktivera bottennotifiering på din e-post om en användare som tidigare registrerats som lead interagerar med boten igen.',
      },
    },
    broadcasts: {
      createBroadcastHeading: 'Skapa sändning',
      youCanCreateMultipleBroadcasts: 'Du kan skapa flera sändningar',
      broadcastName: 'Sändningsnamn',
      broadcastNameIsRequired: 'Sändningsnamn krävs',
      continue: 'Fortsätt',
      manageBroadcasts: 'Hantera sändningar',
      youCanCreateMultipleBroadcastsWithMultipleTemplatesAndSegments:
        'Du kan skapa flera sändningar med flera schemalagda mallar för olika kundgrupper.',
      createNewBroadcast: 'Skapa ny sändning',
      name: 'Namn',
      segment: 'Grupp',
      template: 'Mall',
      contacts: 'Kontakter',
      send: 'Skicka',
      delivered: 'Levererad',
      read: 'Läst',
      failed: 'Misslyckad',
      broadcastAt: 'Sändningsdatum',
      status: 'Status',
      actions: 'Åtgärder',
      nA: 'NA',
      seeHowToUse: 'Se hur du använder',
      deleteBroadcast: 'Radera sändning',
      wantToDeleteThisBroadcast:
        'Är du säker på att du vill radera denna sändning?',
      placeholders: {
        searchHere: 'Sök här',
        enterBroadcastName: 'Ange sändningsnamn',
      },
      appTooltip: {
        deleteMultipleBroadcasts: 'Radera flera sändningar',
        broadcastAnalytics: 'Sändningsanalys',
        deleteBroadcast: 'Radera sändning',
      },
      broadcastAnalytics: {
        broadcastInsights: 'Sändningsinsikter',
        broadcastStatus: 'Sändningsstatus',
        youCanFindDetailsOfEachContactBelow:
          'Du kan hitta detaljer om varje kontakt nedan och exportera de som kan ha problem.',
        filterApplied: 'Filter tillämpat',
        placeholders: {
          searchByPhoneNumber: 'Sök efter telefonnummer',
          searchByName: 'Sök filter efter namn',
        },
        appTooltip: {
          filterDataBasedOnStatus: 'Filtrera data efter status',
          exportData: 'Exportera data',
        },
        modal: {
          exportData: 'Exportera data',
          exportCompleteBroadcastData: 'Exportera komplett sändningsdata',
          export: 'Exportera',
        },
      },
      createBroadcast: {
        broadcastName: 'Sändningsnamn',
        broadcastNameIsRequired: 'Sändningsnamn krävs',
        template: 'Mall',
        segments: 'Grupper',
        whenToSend: 'När ska det skickas',
        now: 'NU',
        later: 'SENARE',
        selectBroadcastUsing: 'Välj sändning med hjälp av',
        usingCsv: 'Använda CSV',
        usingSegment: 'Använda grupp',
        allContacts: 'Alla kontakter',
        selectDate: 'Välj datum',
        selectTimeSlot: 'Välj tidslucka',
        assignVariablesToTemplates: 'Tilldela variabler till mallar',
        addHeaderMedia: 'Lägg till sidhuvudmedia',
        selectFile: 'Välj fil',
        cancel: 'Avbryt',
        createBroadcast: 'Skapa sändning',
        broadcastUsing: 'Sändning med hjälp av',
        selectCSVFile: 'Välj CSV-fil',
        importContacts: 'Importera kontakter',
        beforeYouStartUpload: 'Innan du börjar ladda upp, se till att',
        point1: '1. Ladda ner prov-CSV-filen.',
        point2: '2. Börja mata in dina data från den andra raden och framåt.',
        point3: '3. I varje rad kommer det att finnas data för en kontakt',
        point4: '4. Se till att alla telefonnummer är unika.',
        point5: '5. Den maximala filstorleken för uppladdning är 20 MB',
        // selectFile: 'Select File',
        clickHere: 'Klicka här',
        toDownloadSampleFile: 'för att ladda ner provfilen',
        placeholders: {
          enterBroadcastName: 'Ange sändningsnamn',
          selectTemplate: 'Välj mall',
          searchTemplateByName: 'Sök efter mall efter namn',
          selectSegments: 'Välj grupper',
          selectTimeSlot: 'Välj tidslucka',
          selectValueForThisVariable: 'Välj värde för denna variabel',
          searchHeaderByVariableName: 'Sök sidhuvudvariabel efter namn',
          variableFallbackValue: 'Variabelns fallback-värde',
          searchBodyVariableByName: 'Sök efter kroppens variabel efter namn',
          searchSegmentByName: 'Sök grupp efter namn',
          selectBroadcastUsing: 'Välj sändning med hjälp av',
        },
        indexMergeDatePicker: {
          selectStartDate: 'Välj startdatum',
        },
        appTooltip: {
          importContactsForWhatsappBroadcast:
            'Importera kontakter för whatsapp-sändning',
        },
      },
      failedBroadcast: {
        whatsappNumber: 'WhatsApp-nummer',
        errorCode: 'Felkod',
        errorMessage: 'Felmeddelande',
        nA: 'NA',
      },
    },
    design: {
      customizeYourLandingPage: 'Anpassa din landningssida',
      customizeYourConversationalBot: 'Anpassa din AI-bot',
      customizeYourBot: 'Anpassa din bot',
      createHeadingTextAndTheme: `Skapa rubriktext och tema som speglar din varumärkespersonlighet`,
      content: 'Innehåll',
      theme: 'Tema',
      layout: 'Layout',
      landingPageName: 'Namn på landningssidan',
      botName: 'Botnamn',
      charactersRemaining: ' tecken kvar',
      landingPageHeader: 'Landningssidans rubrik',
      landingPageDescription: 'Landningssidans beskrivning',
      hideContent: 'Dölj innehåll',
      profilePic: 'Profilbild',
      selectFile: 'Välj fil',
      socialMediaLinks: 'Länkar till sociala medier',
      initialMessage: 'Inledande meddelande från konversationsboten',
      flowTriggerDetail: 'Utlösare för att samla kontaktuppgifter',
      selectType: 'Välj typ',
      url: 'URL',
      delete: 'Ta bort',
      editLink: 'Redigera länk',
      addLink: 'Lägg till länk',
      callToAction: 'Handlingsuppmaning',
      liveChatWelcomeMessage: 'Välkomstmeddelande för live-chatt',
      liveChatTriggerMessage: 'Utlösningsmeddelande för live-chatt',
      autoHideCallToAction: 'Dölj Handlingsuppmaning automatiskt',
      maxDelayShouldBe300Seconds: 'Max fördröjning bör vara 300 sekunder',
      landingPageThemeColor: 'Färgtema för landningssidan',
      themeColor: 'Färgtema',
      landingPageBackground: 'Bakgrund för landningssidan',
      chatBackgroundColor: 'Färg på chattens bakgrund',
      color: 'Färg',
      gradient: 'Gradient',
      image: 'Bild',
      video: 'Video',
      gradientStart: 'Gradientens start',
      gradientEnd: 'Gradientens slut',
      positionOnWeb: 'Position på webben',
      positionOnMobile: 'Position på mobilen',
      windowSize: 'Fönsterstorlek',
      s: 'S',
      m: 'M',
      l: 'L',
      xl: 'XL',
      xxl: 'XXL',
      custom: 'Anpassad',
      height: 'Höjd',
      minimum300HeightIsRequired: 'Minst 300px höjd krävs',
      heightCannotExceed720: 'Höjden får inte överstiga 720px',
      width: 'Bredd',
      px: 'px',
      minimum200WidthIsRequired: 'Minst 200px bredd krävs',
      widthCannotExceed1050: 'Bredd får inte överstiga 1050px',
      discard: 'Förkasta',
      saveChanges: 'Spara ändringar',
      landingPageBot: 'Landningssidebot',
      chatBot: 'Chattbot',
      preview: 'Förhandsvisning',
      botIcon: 'Botikon',
      websiteBot: 'Webbplatsens chattbot',
      selectFont: 'Välj typsnitt',
      fontLibrary: 'Typsnittsbibliotek',
      uploadFont: 'Ladda upp typsnitt',
      selectFontForBot: 'Välj typsnitt för boten',
      uploadedFont: 'Uppladdat typsnitt',
      placeholders: {
        enterName: 'Ange namn',
        enterHeaderText: 'Ange rubriktext',
        enterDescription: 'Ange beskrivning',
        enterUrl: 'Ange URL',
        howCanIHelpYou: 'Hur kan jag hjälpa dig?',
        enterYourWelcomeMessageHere: 'Ange ditt välkomstmeddelande här',
        enterYourLiveChatMessageHere: 'Ange ditt live-chattmeddelande här',
        enterTimeInSeconds: 'Ange tid i sekunder',
        enterHeight: 'Ange höjd',
        enterWidth: 'Ange bredd',
        flowInitialMessage: 'Ange inledande fråga',
      },
      appTooltip: {
        standardLayout: 'Standardlayout',
        rightLayout: 'Högerlayout',
        mergedLayout: 'Sammanfogad layout',
        enterNameOfYourBot: 'Ange namn på din bot',
        enterNameOfYourLandingPageBot: 'Ange namn på din landningssidebot',
        headingTextThatAppearOnLandingPageBot:
          'Ange rubriktexten som du vill att din landningssidebot ska visa',
        descriptionTextThatAppearOnLandingPageBot:
          'Ange beskrivningstexten som du vill att din landningssidebot ska visa.',
        addLinksAndSocialMediaIcons: 'Lägg till länkar och ikoner för sociala medier',
        initialFlowMessage:
          'Ange det första meddelandet som boten kommer att skicka för att inleda konversationen med kunden',
        anInvitingCatchPhrase:
          'En inbjudande fångfras som får användaren att prata med botten',
        setAWelcomeMessageForYourVisitors:
          'Ställ in ett välkomstmeddelande för dina besökare. Detta kommer att vara det första meddelandet i din konversation.',
        setAMessageToInitiateLiveChat: `Ställ in ett meddelande för att starta live-chatt från besökarens sida. Du kommer att få en avisering varje gång detta meddelande utlöses
        i någon av dina konversationer.`,
        autoHideCallToAction: `Dölj automatiskt texten 'Handlingsuppmaning' efter angiven tid`,
        TOOLTIP_HIDE_LANDINGPAGE_INFO:
          'Du kan välja att dölja logotypen och texterna för att endast visa chattfönstret på skärmen',
        TOOLTIP_LANDINGPAGE_PROFILE_ICON: 'Ladda upp en logotyp för chattbotssidan.',
        TOOLTIP_CHAT_THEME_COLOR: 'Välj färg på din bots chattfönster',
        TOOLTIP_CHAT_THEME_BACKGROUND_COLOR:
          'Välj bakgrundsfärg för botens chattfönster',
        TOOLTIP_WEB_1ST_POSITION:
          'Positionera din bot längst ner till vänster på botanvändarens skrivbord',
        TOOLTIP_WEB_2ND_POSITION:
          'Positionera din bot i mitten av det högra hörnet på botanvändarens skrivbord',
        TOOLTIP_WEB_3RD_POSITION:
          'Positionera din bot längst ner till höger på botanvändarens skrivbord',
        TOOLTIP_MOBILE_1ST_POSITION:
          'Positionera din bot längst ner till vänster på botanvändarens mobil',
        TOOLTIP_MOBILE_2ND_POSITION:
          'Positionera din bot i mitten av det högra hörnet på botanvändarens mobil',
        TOOLTIP_MOBILE_3RD_POSITION:
          'Positionera din bot längst ner till höger på botanvändarens mobil',
        TOOLTIP_WINDOW_HEIGHT: 'Ändra storlek på bots chattfönster',
        TOOLTIP_BOT_ICON: 'Välj en ikon eller ladda upp en logotyp/bild för din bot',
        flowTriggerMessage:
          'Ange antalet meddelanden som ska frågas innan kontaktuppgifter som namn, e-post och telefonnummer samlas in',
      },
    },
    dripCampaigns: {
      createDripCampaignHeader: 'Skapa droppkampanj',
      youCanCreateMultipleCampaigns: 'Du kan skapa flera kampanjer',
      dripCampaignName: 'Namn på droppkampanjen',
      dripCampaignNameIsReuired: 'Namn på droppkampanjen krävs',
      continue: 'Fortsätt',
      manageDripCampaign: 'Hantera droppkampanj',
      youCanCreateMultipleCampaignsWith:
        'Du kan skapa flera droppkampanjer med schemalagda,' +
        ' automatiserade meddelanden för att utlösa svar från specifika användargrupper.',
      createNewDripCampaign: 'Skapa ny droppkampanj',
      campaignName: 'Kampanjnamn',
      appliedOn: 'Tillämpas på',
      segment: 'Grupp',
      template: 'Mall',
      startDate: 'Startdatum',
      action: 'Åtgärd',
      nA: 'NA',
      seeHowToUse: 'Se hur du använder det',
      deleteDripCampaign: 'Ta bort droppkampanjer',
      wantToDeleteThisDripCampaign:
        'Är du säker på att du vill ta bort dessa droppkampanjer?',
      placeholders: {
        enterDripCampaignName: 'Ange namn på droppkampanjen',
        searchByName: 'Sök efter namn',
      },
      appTooltip: {
        deleteMultipleDripCampaigns: 'Ta bort flera droppkampanjer',
        deleteDripCampaign: 'Ta bort droppkampanj',
      },
      createDripCampaign: {
        dripCampaignName: 'Namn på droppkampanjen',
        appliedOn: 'Tillämpas på',
        segments: 'Grupper',
        selectDate: 'Välj datum',
        scheduleYourTemplate: 'Schemalägg dina mallar',
        schedule: 'Schemalägg',
        template: 'Mall',
        sendAfter: 'Skicka efter',
        assignVariablesToTemplate: 'Tilldela variabler till mallar',
        addHeaderMedia: 'Lägg till sidhuvudmedia',
        selectFile: 'Välj fil',
        createDripCampaign: 'Skapa droppkampanj',
        newSubscriber: 'Ny prenumerant',
        minutes: 'Minuter',
        hours: 'Timmar',
        days: 'Dagar',
        placeholders: {
          enterDripName: 'Ange droppnamn',
          selectAppliedOn: 'Välj tillämpad på',
          selectSegments: 'Välj grupper',
          searchByName: 'Sök efter namn',
          selectTemplate: 'Välj mall',
          searchTemplateByName: 'Sök efter mall efter namn',
          enterSendAfter: 'Ange skicka efter',
          selectValueForThisVariable: 'Välj värde för denna variabel',
          searchHeaderVariableByName: 'Sök efter sidhuvudsvariabel efter namn',
          searchBodyVariableByName: 'Sök efter kroppsvariabel efter namn',
        },
        dateTimePicker: {
          selectStartDate: 'Välj startdatum',
        },
      },
    },
    general: {
      configureLandingPageGeneralSettings: `Konfigurera landningssidans allmänna inställningar`,
      configureBotsGeneralSettings: `Konfigurera botens allmänna inställningar`,
      selectTheTimeZone: 'Välj tidszon, språk och en liten anteckning till dina kunder när ',
      isNotAvailable: ` inte är tillgänglig`,
      landingPagesBot: `landningssidans bot`,
      bot: 'bot',
      waitingMessage: 'Väntemeddelande',
      landingPageBotStatus: 'Status för landningssidebot',
      chatBotStatus: 'Status för chattbot',
      unavailabilityMessage: 'Ej tillgängligt-meddelande',
      sendIncompleteResponses: 'Skicka ofullständiga svar',
      language: 'Språk',
      invalidateCache: 'Ogiltigförklara cache',
      timezone: 'Tidszon',
      chatWindowMessageHistory: 'Chattfönstrets meddelandehistorik',
      session: 'session',
      forever: 'för alltid',
      english: 'Engelska',
      spanish: 'Spanska',
      french: 'Franska',
      portuguese: 'Portugisiska',
      german: 'Tyska',
      italian: 'Italienska',
      swedish: 'Svenska',
      arabic: 'Arabiska',
      malay: 'Malaysiska',
      russian: 'Ryska',
      discard: 'Förkasta',
      saveChanges: 'Spara ändringar',
      seeHowToUse: 'Se hur du använder det',
      placeholders: {
        enterYourWaitingMessageHere: 'Ange ditt väntemeddelande här',
        searchTimeZone: 'Sök tidszon',
      },
      appTooltip: {
        TOOLTIP_WAITING_MESSAGES:
          'Anpassa meddelandet så som du vill att det ska visas på chattfönstret omedelbart efter att en botanvändare har skickat en förfrågan om live-chatt',
        TOOLTIP_CHATBOT_STATUS: 'Aktivera / inaktivera botten',
        TOOLTIP_UNAVAILABILITY_MESSAGE:
          'Anpassa meddelandet så som du vill att det ska visas på chattfönstret när ingen av dina agenter är tillgänglig för live-chatt med botanvändaren',
        TOOLTIP_SEND_INCOMPLETE_RESPONSES:
          'Skicka e-postaviseringar även när botanvändaren inte har avslutat konversationen.',
        TOOLTIP_LANGUAGE: 'Välj botten språk',
        TOOLTIP_INVALIDATE_CACHE:
          'Klicka här för att rensa cachen när du redigerar botchattflöde eller inställningar eftersom ändringar endast syns efter 15 minuter',
        TOOLTIP_TIME_ZONE: 'Välj tidszon för din bot',
        TOOLTIP_CHAT_RETENTION:
          'Välj om du vill behålla botanvändarens chatt för alltid på chattfönstret eller endast för en webbläsarsession.',
      },
    },
    liveChat: {
      customizeYourChatWindow: 'Anpassa ditt chattfönster',
      controlAndCustomizeTheChatWindow:
        'Kontrollera och anpassa chattfönstret som dina kunder kommer att interagera med.',
      allowVisitorsToTransferChatToWhatsapp: 'Tillåt besökare att överföra chatt till WhatsApp',
      allowVisitorsToRefreshChat: 'Tillåt besökare att uppdatera chatt',
      displayNameForTransferringChatToWhatsapp: 'Visningsnamn för överföring av chatt till Whatsapp',
      displayNameForTransferringToLiveChat: 'Visningsnamn för överföring till live-chatt/agent',
      displayNameForTransferringAChatToBot: 'Visningsnamn för överföring av chatt till bot',
      discard: 'Förkasta',
      saveChanges: 'Spara ändringar',
      allowVisitorsToTransferChatToBot: 'Tillåt besökare att överföra chatt till bot.',
      allowVisitorsToRequestForLiveChat: 'Tillåt besökare att begära live-chatt.',
      indicativeTextForCustomersReply: `Indikativ text för kundens svar`,
      displayNameForRestartingChatBot: 'Visningsnamn för omstart av chatbot-konversation',
      seeHowToUse: 'Se hur du använder det',
      placeholders: {
        enterButtonNameForWhatsapp: 'Ange knappnamn för överföring till WhatsApp',
        enterButtonNameForLiveChat: 'Ange knappnamn för överföring till live-chatt eller agent',
        enterButtonNameForBot: 'Ange knappnamn för överföring till bot',
        enterTextDisplayInEmptyReplyArea: 'Ange texten som visas i det tomma svarområdet',
        enterButtonForRestartingConversation: 'Ange knappnamn för omstart av konversation',
      },
      appTooltip: {
        TOOLTIP_TRANSFER_CHAT_TO_WHATSAPP:
          'Tillåt webbplatsbesökare att överföra chatten till WhatsApp-numret för den respektive agent de är anslutna till. Live-chattfunktionen måste vara aktiverad för att den här funktionen ska fungera.',
        TOOLTIP_ALLOW_VISITOR_TO_REFRESH_CHAT:
          'Tillåt botanvändare att uppdatera chatten så att de kan börja konversationen på nytt.',
        TOOLTIP_ALLOW_TRANSFER_CHAT_TO_BOT:
          'Tillåt botanvändare att överföra chatten till boten när som helst under konversationen med live-chattagenten.',
        TOOLTIP_ALLOW_REQUEST_FOR_CHAT:
          'Tillåt botanvändare att begära live-chatt med agenten när de vill.',
        ifYouHaveEnabledUserToTransferToWhatsapp:
          'Om du har aktiverat användaren att överföra till WhatsApp, fyll i hur du vill visa den möjligheten',
        ifYouHaveEnabledUserToTransferToLiveChat:
          'Om du har aktiverat användaren att överföra till live-chatt, fyll i hur du vill visa den möjligheten',
        ifYouHaveEnabledUserToTransferToWhatsapp2:
          'Om du har aktiverat användaren att överföra till WhatsApp, fyll i hur du vill överföra tillbaka till boten',
        howWouldYouLikeToDisplayReplySpaceForCustomers:
          'Fyll i hur du vill visa svarsutrymmet för kunderna',
        ifYouHaveEnabledUserToRestartChatBot:
          'Om du har aktiverat användaren att starta om chatbot-konversationen, fyll i hur du vill visa den möjligheten',
      },
    },
    socialPlatforms: {
      chatFlowsHeader: 'Chattflöden',
      dripCampaignHeader: 'Droppkampanj',
      widgetsHeader: 'Widgetar',
      broadcastHeader: 'Sändning',
      ordersHeader: 'Ordrar',
      manageHeader: 'Hantera',
      inputHeader: 'Inmatning',
      apiKeyHeader: 'API-nyckel',
      appTooltip: {
          TOOLTIP_DRIP_CAMPAIGN_TITLE:
              'Skapa en kundintroduktionsresa med en droppkampanj av schemalagda chattflöden.',
          TOOLTIP_CHAT_FLOW_TITLE:
              'Anpassa chattflödestemplaten och skapa flera chattflöden för olika målgrupper.',
          TOOLTIP_WIDGET_TITLE:
              'Skapa widgetar (chattgränssnitt) och bädda in dem i kampanjsidor för att dirigera besökare till botten.',
          TOOLTIP_BROADCAST_TITLE:
              'Skicka meddelanden eller flöden till dina kontakter med en enda klick vid den förbestämda tiden.',
          TOOLTIP_ORDERS_TITLE: 'Lista över ordrar som gjorts av kunden',
          TOOLTIP_MANAGE_TITLE:
              'Hantera botfunktionalitet för kontakter/leads och nyckelord',
          TOOLTIP_INPUT_TITLE:
              'Skapa WhatsApp-templates, bilder och text som svarsmaterial för kontakter/leads',
      },
      apiWrapper: {
          whatsappApiCredentials: 'WhatsApp API-legitimation',
          generateYourWhatsappApiKey:
              'Generera din WhatsApp API-nyckel för att integrera med dina anpassade utvecklade appar.',
          generateApiKey: 'Generera API-nyckel',
          webhookUrl: 'Webhook URL',
          addHeader: 'Lägg till rubrik',
          test: 'Test',
          webhookNotSet: 'Webhook inte inställd',
          webhookHeaders: 'Webhook-rubriker',
          setWebhookUrl: 'Ange Webhook-url',
          placeholders: {
              yourApiKey: 'Din API-nyckel',
              enterWebhookUrl: 'Ange Webhook-url',
              enterHeaderKey: 'Ange rubriknyckel',
              enterValue: 'Ange värde',
          },
      },
      broadcast: {
          contentType: 'Innehållstyp',
          nonPromotional: 'Icke-promotionell (taggar tillämpade)',
          tagEachMessgeThatComesBeforeAnyInteraction:
              'Tagga varje meddelande som kommer före någon interaktion eller efter fördröjningssteg som överstiger 24 timmar med lämplig tagg. Otaggade meddelanden når inte abonnenter som har interagerat med botten för över 24 timmar sedan',
          promotional: 'Promotionell (meddelandetaggar ignoreras)',
          theseBroadcasts:
              'Dessa sändningar kan innehålla erbjudanden, men målgruppen är begränsad till prenumeranter som interagerade med din bot de senaste 24 timmarna.',
          createNewBroadcast: 'Skapa ny sändning',
          sentMessages: 'Skickade meddelanden',
          deliveredMessages: 'Levererade meddelanden',
          readMessages: 'Lästa meddelanden',
          failedMessages: 'Misslyckade meddelanden',
          type: 'Typ',
          template: 'Mall',
          sent: 'Skickat',
          delivered: 'Levererat',
          read: 'Läst',
          failed: 'Misslyckat',
          broadcastAt: 'Sändningstidpunkt',
          status: 'Status',
          shipmentUpdate: 'Följesedelsuppdatering',
          flow: 'Flöde',
          resendFailedMessages: 'Skicka om misslyckade meddelanden',
          number: 'Nummer',
          errorCode: 'Felkod',
          failedAt: 'Misslyckades vid',
          badGateway: '502 dålig gateway',
          loadMore: 'Ladda mer',
          placeholders: {
              enterBroadcastName: 'Ange sändningsnamn',
              searchBroadcastByName: 'Sök sändning efter namn',
          },
          appTooltip: {
              totalBroadcastMessagesSent: 'Totalt antal skickade sändningsmeddelanden',
              totalBroadcastMessagesDelivered: 'Totalt antal levererade sändningsmeddelanden',
              totalBroadcastMessagesReadByContacts:
                  'Totalt antal sändningsmeddelanden som lästs av kontakterna',
              totalFailedBroadcastMessages: 'Totalt antal misslyckade sändningsmeddelanden',
              clickToViewDetailedInformationOfFailedMessages:
                  'klicka för att visa detaljerad information om misslyckade meddelanden',
              clickToCreateNewBroadcast: 'Klicka för att skapa ny sändning',
              templateUsedInBroadcast: 'Mall använd i sändningen',
              numberOfBroadcastMessagesSent: 'Antal sändningsmeddelanden skickade',
              numberOfBroadcastMessagesDelivered:
                  'Antal sändningsmeddelanden levererade',
              numberOfBroadcastMessagesReadByContacts:
                  'Antal sändningsmeddelanden som lästs av kontakterna',
              numberOfTimesBroadcastMessagesHasFailed:
                  'Antal gånger sändningsmeddelanden har misslyckats',
              contactNumberOnWhichMessageDeliveryFailed:
                  'Kontaktnummer där leverans av meddelande misslyckades',
              unDeliveredTemplate: 'Olevererad mall',
              errorReceivedForFailedMessage: 'Fel mottaget för misslyckat meddelande',
              timeWhenMessageDeliveryFailed: 'Tidpunkt när meddelandeleverans misslyckades',
              TOOLTIP_ADD_BROADCAST_NAME: 'Ange ett nytt sändningsnamn',
              TOOLTIP_BROADCAST_SELECT_TYPE:
                  'Välj om du sänder ett flöde eller ett meddelande.',
              TOOLTIP_BROADCAST_FLOW: 'Välj det chattflöde du vill sända,',
              TOOLTIP_BROADCAST_SELECT_YOUR_SEGMENT:
                  'Välj kontaktförfrågningsgruppen du vill sända till',
              TOOLTIP_BROADCAST_NAME: 'Namn på sändningen',
              TOOLTIP_BROADCAST_TYPE: 'Flöde eller meddelande valt för sändningen',
              TOOLTIP_BROADCAST_SEGMENT: 'Grupp för vilken sändningen skapas',
              TOOLTIP_BROADCAST_AT: 'Datum och tidpunkt schemalagd för sändningen',
              TOOLTIP_BROADCAST_STATUS:
                  'Sändningsstatus som schemalagd, pågår för närvarande eller avslutad',
          },
      },
      drip: {
          createDripCampaign: 'Skapa droppkampanj',
          youCanCreateMultipleCampaigns: 'Du kan skapa flera kampanjer',
          dripCampaignName: 'Droppkampanjnamn',
          dripCampaignNameIsRequired: 'Droppkampanjnamn krävs',
          youCanCreateMultipleDripCampaigns:
              'Du kan skapa flera droppkampanjer med schemalagda, automatiserade meddelanden för att utlösa svar från specifika användargrupper.',
          campaignName: 'Kampanjnamn',
          campaignNameIsRequired: 'Kampanjnamn krävs',
          after: 'Efter ',
          thisMessageWillBeSendAfter: 'Detta meddelande kommer att skickas efter',
          saveAndUpdate: 'Spara & Uppdatera',
          schedule: ' Schema',
          select: 'Välj',
          messages: 'Meddelanden',
          cancel: 'Avbryt',
          createCampaign: 'Skapa kampanj',
          updateCampaign: 'Uppdatera kampanj',
          createNewCampaign: 'Skapa ny kampanj',
          messagesSent: 'Skickade meddelanden',
          createdAt: 'Skapad den',
          updatedAt: 'Uppdaterad den',
          action: 'Åtgärd',
          placeholders: {
              nameYourDripCampaign: 'Namnge din droppkampanj',
              enterCampaignName: 'Ange kampanjnamn',
              searchCampaignByName: 'Sök kampanj efter namn',
          },
          appTooltip: {
              TOOLTIP_CREATE_CAMPAIGN: 'Klicka för att lägga till en ny kampanj',
              TOOLTIP_SCHEDULE:
                  'Planera när och vilket chattflöde som ska skickas först i denna kampanj.',
              TOOLTIP_AFTER_DAYS:
                  'Schemalägg när du ska skicka det första flödet i kampanjen i minuter, timmar eller dagar.',
              TOOLTIP_ADD_MESSAGES: 'Klicka för att lägga till ett nytt flöde i kampanjen',
              TOOLTIP_ADD_CAMPAIGN_NAME: 'Ange ett nytt kampanjnamn',
              TOOLTIP_CAMPAIGN_NAME: 'Namn på kampanjen',
              TOOLTIP_NO_MESSAGES_SENT: 'Antal meddelanden skickade av kampanjen',
              TOOLTIP_CAMPAIGN_CREATED_AT:
                  'Datum och tid för skapande av kampanjen',
              TOOLTIP_CAMPAIGN_UPDATED_AT:
                  'Datum och tid då kampanjen senast modifierades',
              TOOLTIP_CAMPAIGN_ACTION: 'Redigera eller ta bort kampanjen',
              TOOLTIP_UPDATE_CAMPAIGN:
                  'Klicka för att spara de modifieringar som gjorts i kampanjuppställningen',
          },
      },
      flows: {
        createChatFlow: 'Skapa Chattflöde',
        youCanCreateMultipleConversationsFlow:
            'Du kan skapa flera konversationsflöden över flera kanaler för A/B-testning och sändningar.',
        flowName: 'Flödesnamn',
        nameIsRequired: 'Namn krävs',
        cancel: 'Avbryt',
        createFlow: 'Skapa Flöde',
        createNewFlow: 'Skapa Nytt Flöde',
        ofMessages: 'av meddelanden',
        triggered: 'Utlöst',
        stepsFinsished: 'Steg avslutade',
        finished: 'Avslutat',
        createdOn: 'Skapad den',
        lastModified: 'Senast ändrad',
        defaultFlow: 'Standardflöde',
        action: 'Åtgärd',
        flowAnalytics: 'Flödesanalys',
        placeholders: {
            enterFlowName: 'Ange flödesnamn',
            searchFlowByName: 'Sök efter flöde efter namn',
        },
        appTooltip: {
            numberOfTimesChatFlowTriggered: 'Antal gånger chattflödet utlöses',
            numberOfCompletedChatFlowStepsWhenTriggered: 'Antal avslutade steg när chattflödet utlöses',
            numberOfTimesUsersCompletedChatFlowSteps: 'Antal gånger användare har avslutat alla steg i chattflödet',
            dateAndTimeOfCreationOfChatFlow: 'Datum och tid för skapande av chattflödet',
            dateAndTimeWhenChatFlowLastModified: 'Datum och tid när chattflödet senast ändrades',
            TOOLTIP_CREATE_FLOW: 'Klicka för att skapa ett nytt chattflöde',
            TOOLTIP_FLOW_NAME: 'Ange namnet på chattflödet',
            TOOLTIP_FLOW_TABLE_NAME: 'Namn på chattflödet',
            TOOLTIP_NO_OF_MESSAGES: 'Antal meddelandekomponenter i chattflödet',
            TOOLTIP_DEFAULT_FLOW: 'Använd denna växel för att ställa in ett chattflöde som standard, vilket kommer att serveras till alla nya användare.',
            TOOLTIP_ACTION: 'Redigera eller ta bort chattflödet',
        },
      },
      manage: {
          leads: 'Leads',
          manageBotsFunctionalityForContacts: `Hantera bottenfunktionalitet för kontakter/leads`,
          whenToSendLeadInfo: 'När ska ledinformation skickas',
          smartFlow: 'Smart Flöde',
          welcomeMessageWhenNoSearchKeywordIsMet: 'Välkomsthälsning när ingen söknyckel matchas',
          selectTemplates: 'Välj Mallar',
          selectFlows: 'Välj Flöden',
          selectText: 'Välj Text',
          selectImages: 'Välj Bilder',
          whenItAlmostReaches24HoursSinceMessage: 'När det nästan når 24 timmar sedan sista meddelandet',
          updateChanges: 'Uppdatera Ändringar',
          manageBotsFunctionalityAccordingToKeywords: `Hantera bottenfunktionalitet enligt nyckelord angivna av bottenanvändaren, vid smart flöde`,
          addKeywordAction: 'Lägg till Åtgärd för Nyckelord',
          keywords: 'Nyckelord',
          matchingMethod: 'Matchningsmetod',
          replyMaterial: 'Svars material',
          action: 'Åtgärd',
          select: 'Välj',
          placeholders: {
              keyword: 'nyckelord',
          },
          appTooltip: {
              TOOLTIP_LEADS_WHEN_TO_SEND_LEAD: 'Föreslå om botten ska skicka kontakt-/leadinformation till integrations-CRM omedelbart, eller efter 5 minuter, eller i slutet av flödet',
              TOOLTIP_LEAD_SMART_FLOW: 'Välj valfritt standardflöde för att skicka det till alla bottenanvändare, eller smart flöde (bestämt av nyckelorden angivna av bottenanvändaren).',
              TOOLTIP_LEAD_WELCOME_MESSAGE: 'Välj svars material (flöde, mall, text, bild) att skicka om botten inte får någon nyckelmatchning från bottenanvändarens svar',
              TOOLTIP_IT_ALMOST_REACHED: 'Välj svars material att skicka till kontakter/leads precis innan 24 timmar sedan senaste meddelandet',
              TOOLTIP_KEYWORD_ACTION_TITLE: 'Hantera bottenfunktionalitet enligt nyckelord angivna av bottenanvändaren, vid smart flöde',
              TOOLTIP_ADD_KEYWORD_ACTIONS_HEADING: 'Välj bottensvar som mall, flöde, text eller bild mot specifika angivna nyckelord',
              TOOLTIP_ADD_KEYWORD: 'Lägg till nyckelord',
              TOOLTIP_MATCHING_METHOD: 'Lägg till nyckelordsmatchning som \'exakt\' eller \'innehåller\'',
              TOOLTIP_REPLY_MATERIAL: 'Välj mall, flöde, text eller bild för att svara på det föreslagna nyckelordet',
              TOOLTIP_KEYWORD_ACTIONS: 'Ta bort åtgärden för nyckelordet',
          },
          socialAlerts: {
              alerts: 'Aviseringar',
              specifyHowYourBotWillNotify: 'Ange hur din bot kommer att meddela dig om nya leads.',
          },
      },
      orders: {
          manageCustomersOrder: 'Hantera Kundbeställningar',
          checkAndManageAllOfYourCustomerOrders: 'Kontrollera och hantera alla dina kundbeställningar och uppdateringar.',
          selectShipmentTemplate: 'Välj Leveransmall',
          send: 'Skicka',
          export: 'Exportera',
          phoneNumber: 'Telefonnummer',
          numberOfItems: 'Antal föremål',
          orderValue: 'Beställningsvärde',
          orderDate: 'Beställningsdatum',
          status: 'Status',
          chat: 'Chatt',
          item: 'Föremål',
          quantity: 'Kvantitet',
          amount: 'Belopp',
          unitPrice: 'Enhetspris',
          placeholders: {
              searchOrdersByPhoneNumber: 'Sök efter beställningar efter telefonnummer',
          },
          appTooltip: {
              exportOrdersDataInCSVFile: 'Exportera orderdata i CSV-fil',
              TOOLTIP_ORDERS_PHONE_NO: 'Telefonnummer till kunden som lade beställningen',
              TOOLTIP_NO_OF_ITEMS: 'Antal beställda föremål',
              TOOLTIP_ORDER_VALUE: 'Värde på beställningen',
              TOOLTIP_ORDER_DATE: 'Beställningen gjordes detta datum.',
              TOOLTIP_ORDER_STATUS: 'Status för beställningen som bekräftad, avvaktande, avvisad. eller skickad',
              TOOLTIP_ORDER_CHAT: 'Alla tidigare chattkonversationer om denna order',
          },
      },
      widgets: {
          installWidgetHeader: 'Installera Widget',
          createWidgetHeader: 'Skapa Widget',
          copyTheCodeAndPasteItWhereYouWant: 'Kopiera koden och klistra in den där du vill i din HTML, webbplats osv.',
          youCanCreateMultipleWidgets: 'Du kan skapa flera widgets för att ge din bot olika utseenden på olika webbsidor.',
          installWidget: {
              javascript: 'Javascript',
              install: 'Installera ',
              onYourWebsite: ' på din webbplats',
              copyCode: 'Kopiera kod',
              copyAndPaste: 'Kopiera och klistra in',
              copyThisCodeSnippet: 'Kopiera denna kodsnutt och infoga den i HTML på varje webbsida där du vill visa Widgeten. För mer detaljer',
              seeGuide: 'se guide',
          },
          widgetList: {
              widgetName: 'Widgetnamn',
              nameIsRequired: 'Namn krävs',
              cancel: 'Avbryt',
              createWidget: 'Skapa Widget',
              icon: 'Ikon',
              name: 'Namn',
              createdAt: 'Skapad den',
              action: 'Åtgärd',
              placeholders: {
                  enterWidgetName: 'Ange widgetnamn',
                  searchWidgetByName: 'Sök efter widget efter namn',
              },
              appTooltip: {
                  widgetIcon: 'Widgetikon',
                  nameOfWidget: 'Namn på widgeten',
                  dateAndTimeOfCreationOfWidget: 'Datum och tid för skapande av widgeten',
                  editOrDeleteWidget: 'Redigera eller ta bort widgeten',
              },
          },
          widgetTemplates: {
              widgetName: 'Widgetnamn',
              nameIsRequired: 'Namn krävs',
              chooseTypeOfWidget: 'Välj typ av Widget',
              bar: 'Bar',
              slideIn: 'Skjut In',
              pageTakeOver: 'Sidövertagande',
              button: 'Knapp',
              facebookModal: 'Facebook-modal',
              comment: 'Kommentar',
              direct: 'Direkt',
              whatsappIcon: 'WhatsApp-ikon',
              refUrl: 'Ref-URL',
              qrCode: 'QR-kod',
              backgroundColor: 'Bakgrundsfärg',
              descriptionColor: 'Beskrivningsfärg',
              headlineColor: 'Rubrikfärg',
              buttonBackgroundColor: 'Knappens bakgrundsfärg',
              contactNumber: 'Kontaktnummer',
              entryMessage: 'Ingångsmeddelande',
              buttonText: 'Knappens text',
              selectButtonText: 'Välj knappens text',
              buttonSize: 'Knappens storlek',
              selectOne: 'Välj en',
              placement: 'Placering',
              rightBottom: 'Höger-Nedre',
              optInFlow: 'Opt-in Flöde',
              selectFlow: 'Välj Flöde',
              addSubscriberToSequence: 'Lägg till prenumerant i sekvens',
              selectDrip: 'Välj Drip',
              whenDoesItDisplay: 'När visas den (Sekunder)',
              showWidgetToSameUserAgainAfter: 'Visa widgeten för samma användare igen efter',
              ifManuallyClosedByUser: 'Om den manuellt stängs av användaren, visa efter',
              specificPosts: 'Specifika Inlägg',
              allPosts: 'Alla Inlägg',
              postMessage: 'Inläggsmeddelande',
              postDate: 'Inläggsdatum',
              status: 'Status',
              action: 'Åtgärd',
              discard: 'Förkasta',
              saveChanges: 'Spara Ändringar',
              nextStep: 'Nästa Steg',
              widgetDescription: 'Widgetbeskrivning',
              integrateTheBarWidget: 'Integrera Bar Widget på din webbplats och öka antalet prenumeranter på sidan tillsammans med att skicka dem anpassade bottenmeddelandeflöden.',
              hereIsYourWidgetHeadline: 'Här är din widgetrubrik, klicka här för att ändra den.',
              sendUsMessage: 'Skicka oss ett meddelande',
              weAlsoPutDefaultTextHere: 'Vi lägger också standardtext här. Se till att göra den till ett värdefullt meddelande',
              selectYourPagePost: 'Välj ditt sidoinlägg',
              nA: 'Ej tillämpligt',
              saveRule: 'Spara Regeln',
              placeholders: {
                  enterWidgetName: 'Ange widgetnamn',
                  enterNumber: 'Ange nummer',
                  enterMessageHere: 'Ange meddelande här',
                  enterTimeInSeconds: 'Ange tid i sekunder',
              },
          },
      },

    },
    triggers: {
      customizeYourBotsTriggerSettings: `Anpassa din botts utlösningsinställningar`,
      makeYourBotsTimingPerfect: `Gör din botts timing perfekt.`,
      onDesktopTriggerTime: 'På skrivbordet utlösningstid (sekunder)',
      onMobileTriggerTime: 'På mobil utlösningstid (sekunder)',
      chatBubble: 'Automatisk öppning av chattbubbla',
      seconds: 'Sekunder',
      discard: 'Förkasta',
      saveChanges: 'Spara Ändringar',
      autoTriggerOnOrOff: 'Inaktivera automatisk utlösning',
      seeHowToUse: 'Se hur man använder',
      alwaysOpenAfter: 'Alltid öppen efter ovan angivna utlösare',
      automaticallyAfterSelectedNumberOfTime: 'Automatiskt efter vald tid',
      neverAutomaticallyOpenBot: 'Öppna aldrig boten automatiskt',
      placeholders: {
          enterTimeInSeconds: 'Ange tid i sekunder',
      },
      appTooltip: {
          TOOLTIP_DESKTOP_TRIGGER_TIME: 'Väntetid i sekunder, på besökarens skrivbordsenheter, innan din bot automatiskt dyker upp',
          TOOLTIP_MOBILE_TRIGGER_TIME: 'Väntetid i sekunder, på besökarens mobil, innan din bot automatiskt dyker upp',
          TOOLTIP_CHAT_BUBBLE_OPENING: 'När besökaren stänger chattfönstret, välj hur boten automatiskt ska öppnas beteende',
          customerWaitingTimeToOpenBubble: 'Kundens väntetid för att öppna chattbubblan',
          wantToDisableAutoTriggering: 'Aktivera detta om du inte vill att chattbotten automatiskt öppnas på webbplatsen',
      },
    },
    userAccess: {
        customizeYourBotsSettings: `Anpassa din botts användarinställningar`,
        decideWhoCanAccessYourBot: 'Bestäm vem som kan komma åt din bot',
        deviceSupport: 'Enhetstöd',
        blockIpAddresses: 'Blockera IP-adresser',
        hideChatBotOnSpecificPages: 'Dölj chattbotten på specifika sidor',
        selectCountriesToEnableBot: 'Välj länder för att aktivera botten',
        discard: 'Förkasta',
        saveChanges: 'Spara Ändringar',
        seeHowToUse: 'Se hur man använder',
        allDevices: 'Alla enheter',
        mobileOnly: 'Endast mobil',
        desktopOnly: 'Endast skrivbord',
        placeholders: {
            enterIpAddress: `Ange IP-adress (ipv4 eller ipv6) och tryck på ' Enter '`,
            enterUrl: `Ange sidans webbadress och tryck på ' Enter '`,
            searchCountry: 'Sök land',
        },
        appTooltip: {
            TOOLTIP_DEVICE_SUPPORT: 'Välj på vilka enheter din bot ska visas',
            TOOLTIP_BLOCK_IP_ADDRESS: 'Ange IP-adresser där du inte vill att din bot ska visas',
            TOOLTIP_HIDE_CHATBOT_SPECIFIC_PAGES: 'Ange URL för dina webbsidor där du inte vill att din bot ska visas',
            TOOLTIP_COUNTRIES_TO_ENABLE_BOT: 'Välj platser från vilka du vill att användare ska komma åt din bot',
        },
    },
    facebook: {
      facebookBotSettings: 'Facebook Bot-inställningar',
      chatFlowsHeader: 'Chattflöden',
      dripCampaignHeader: 'Drip-kampanj',
      broadcastHeader: 'Sändning',
      widgetsHeader: 'Widgetar',
      autoReplyHeader: 'Auto-svar',
      generalHeader: 'Allmänt',
      facebookAutomation: 'Facebook Automation',
      appTooltip: {
        TOOLTIP_CHAT_FLOW_TITLE:
          'Anpassa chattflödesmallarna och skapa flera chattflöden för olika målgrupper.',
        TOOLTIP_DRIP_CAMPAIGN_TITLE:
          'Skapa en kundintroduktionsresa med hjälp av en drip-kampanj med schemalagda chattflöden.',
      },
      broadcasts: {
        createBroadcast: 'Skapa Sändning',
        youCanCreateMultipleBroadcasts: 'Du kan skapa flera sändningar',
        broadcastName: 'Sändningsnamn',
        broadcastNameIsRequired: 'Sändningsnamn krävs',
        continue: 'Fortsätt',
        manageBroadcasts: 'Hantera Sändningar',
        youCanCreateMultipleBroadcastsWith:
          'Du kan skapa flera sändningar med flera schemalagda mallar för olika kundgrupper.',
        createNewBroadcast: 'Skapa Ny Sändning',
        name: 'Namn',
        segment: 'Grupp',
        template: 'Mall',
        contacts: 'Kontakter',
        send: 'Skicka',
        failed: 'Misslyckades',
        broadcastAt: 'Sändningstidpunkt',
        status: 'Status',
        actions: 'Åtgärder',
        nA: 'NA',
        deleteBroadcast: 'Ta bort Sändning',
        wantToDeleteThisBroadcast:
          'Är du säker på att du vill ta bort denna sändning?',
        placeholders: {
          enterBroadcastName: 'Ange sändningsnamn',
          searchHere: 'Sök här',
        },
        appTooltip: {
          deleteMultipleBroadcasts: 'Ta bort flera sändningar',
          deleteBroadcast: 'Ta bort Sändning',
        },
      },
      createBroadcastFacebook: {
        braodcastName: 'Sändningsnamn',
        broadcastNameIsRequired: 'Sändningsnamn krävs',
        flow: 'Flöde',
        segments: 'Grupper',
        whenToSend: 'När ska det skickas',
        selectDate: 'Välj Datum',
        selectTimeSlot: 'Välj Tidsintervall',
        createBroadcast: 'Skapa Sändning',
        cancel: 'Avbryt',
        now: 'Nu',
        later: 'Senare',
        placeholders: {
          enterBroadcastName: 'Ange sändningsnamn',
          selectFlow: 'Välj Flöde',
          searchFlowByName: 'Sök efter flöde via namn',
          selectSegments: 'Välj Grupper',
          searchSegmentByName: 'Sök efter grupp via namn',
          selectTimeSlot: 'Välj Tidsintervall',
        },
        indexMergeDatePicker: {
          selectStartDate: 'Välj startdatum',
        },
      },
      dripCampaigns: {
        createDripCampaign: 'Skapa Drip-kampanj',
        youCanCreateMultipleCampaign: 'Du kan skapa flera kampanjer',
        dripCampaignName: 'Namn på Drip-kampanj',
        dripCampaignNameIsRequired: 'Namn på Drip-kampanj krävs',
        continue: 'Fortsätt',
        manageDripCampaign: 'Hantera Drip-kampanjer',
        youCanCreateMutlipleDripCampaign:
          'Du kan skapa flera drip-kampanjer med schemalagda, automatiserade meddelanden för att utlösa svar från specifika användargrupper.',
        createNewDripCampaign: 'Skapa Ny Drip-kampanj',
        campaignName: 'Kampanjnamn',
        appliedOn: 'Tillämpad på',
        segment: 'Grupp',
        flow: 'Flöde',
        startDate: 'Startdatum',
        action: 'Åtgärd',
        nA: 'NA',
        deleteDripCampaign: 'Ta bort Drip-kampanjer',
        wantToDeleteThisDripCampaign:
          'Är du säker på att du vill ta bort denna Drip-kampanj?',
        placeholders: {
          enterDripCampaignName: 'Ange Namn på Drip-kampanj',
          searchByName: 'Sök Via Namn',
        },
        appTooltip: {
          deleteMultipleDripCampaigns: 'Ta bort flera drip-kampanjer',
          deleteDripCampaign: 'Ta bort Drip-kampanj',
        },
        createDripCampaignFacebook: {
          dripCampaignName: 'Namn på Drip-kampanj',
          appliedOn: 'Tillämpad på',
          segments: 'Grupper',
          selectDate: 'Välj Datum',
          scheduleYourFlows: 'Schemalägg Dina Flöden',
          schedule: 'Schemalägg',
          flow: 'Flöde',
          sendAfter: 'Skicka Efter',
          cancel: 'Avbryt',
          newSubscriber: 'Ny Prenumerant',
          days: 'Dagar',
          minutes: 'Minuter',
          hours: 'Timmar',
          createDripCampaign: 'Skapa Drip-kampanj',
          placeholders: {
            enterDripName: 'Ange Drip-namn',
            selectAppliedOn: 'Välj Tillämpad på',
            selectSegment: 'Välj Grupp',
            searchByName: 'Sök Via Namn',
            selectTemplate: 'Välj Mall',
            searchFlowByName: 'Sök Flöde Via Namn',
            enterSendAfter: 'Ange Skicka Efter',
          },
          dateTimePicker: {
            selectStartDate: 'Välj startdatum',
          },
        },
      },
      failedBroadcastFacebook: {
        chatId: 'Chatt-ID',
        errorCode: 'Felkod',
        errorMessage: 'Felmeddelande',
        nA: 'NA',
      },
      flows: {
        chatFlows: 'Chattflöden',
        createChatFlow: 'Skapa Chattflöde',
        youCanCreateMultipleChatFlows:
          'Du kan skapa flera konversationsflöden över flera kanaler för A/B-testning och sändningar.',
        flowName: 'Flödesnamn',
        nameIsRequired: 'Namn krävs',
        cancel: 'Avbryt',
        createFlow: 'Skapa Flöde',
        importFlow: 'Importera Flöde',
        createNewFlow: 'Skapa Nytt Flöde',
        ofMessages: 'av meddelanden',
        createdOn: 'Skapat den',
        lastModified: 'Senast ändrad',
        defaultFlow: 'Standardflöde',
        action: 'Åtgärd',
        exportStatus: 'Exportstatus',
        flowExport: 'Flödesexport ',
        download: 'Ladda ner',
        // importFlow: 'Importera Flöde'
        beforeYouStartUploadPleaseMakeSure:
          'Innan du börjar ladda upp, se till att',
        point1: '1. Den maximala filstorleksgränsen för uppladdning är 20 MB',
        point2: '2. Filformatet ska vara i JSON',
        selectFile: 'Välj Fil',
        inProgress: 'pågår',
        available: 'Tillgänglig',
        initiated: 'Initierad',
        placeholders: {
          enterFlowName: 'Ange flödesnamn',
        },
        appTooltip: {
          importFlowForFacebookBot: 'Importera flöde för Facebook-bot',
          dateAndTimeOfCreationOfChatFlow:
            'Datum och tid för skapande av chattflödet',
          dateAndTimeWhenChatFlowLastModified:
            'Datum och tid när chattflödet senast ändrades',
          TOOLTIP_CREATE_FLOW: 'Klicka för att skapa ett nytt chattflöde',
          TOOLTIP_FLOW_NAME: 'Ange chattflödesnamn',
          TOOLTIP_FLOW_TABLE_NAME: 'Namn på chattflödet',
          TOOLTIP_NO_OF_MESSAGES: 'Antal meddelandekomponenter i chattflödet',
          TOOLTIP_DEFAULT_FLOW:
            'Använd detta reglage för att ställa in ett chattflöde som standard, som kommer att serveras till alla nya användare.',
          TOOLTIP_ACTION: 'Redigera eller ta bort chattflödet',
        },
        noDataFound: {
          flows: 'Flöden',
          noFlowsAddedYet: 'Inga flöden tillagda ännu!',
        },
        modal: {
          deleteFlow: 'Ta bort Flöde',
          wantToDeleteThisFlow: 'Är du säker på att du vill ta bort detta flöde?',
        },
      },
      widgets: {
        manageWidgets: 'Hantera Widgetar',
        widgetsAreRoutingTools:
          'Widgetar är verktyg för ruttering för att öka användningen av boten',
        needHelp: 'Behöver du hjälp?',
        wantToMakeChanges: 'Vill du göra ändringar?',
        editIcon: 'Redigera ikon',
        discard: 'Kasta bort',
        updateWidget: 'Uppdatera Widget',
        installChatBotIconOnYourWebsite: 'Installera chatbot-ikon på din webbplats',
        shareWhereEverYouWantToRedirectUsersTo:
          'Dela var du vill och omdirigera användare till din Facebook-bot med en enda klick',
        copyAndAddInYourWebsiteHeaderFile:
          'Kopiera och lägg till i din webbplats header-fil',
        copyLinkAndStartSharing: 'Kopiera länk och börja dela!',
        downloadQrCodeAndStartSharing: 'Ladda ner QR-kod och börja dela!',
        addCodeAndDeployNewCodeAndDone:
          'Lägg till koden, implementera ny koden och Klart!',
        wantToLearnHowToUseIt: 'Vill du lära dig hur man använder det?',
        copyChatBotCode: 'Kopiera Chatbot-kod',
        copyFacebookLink: 'Kopiera Facebook-länk',
        downloadQrCode: 'Ladda ner QR-kod',
        link: 'Länk',
        chatBotIcon: 'Chatbot-ikon',
        qrcode: 'QR-kod',
        small: 'Liten',
        medium: 'Medium',
        large: 'Stor',
        leftMiddle: 'Vänster-Mitte',
        rightMiddle: 'Höger-Mitte',
        leftBottom: 'Vänster-Nedre',
        rightBottom: 'Höger-Nedre',
        bpDropDown: {
          selectIcons: 'Välj ikoner',
          iconSize: 'Ikonstorlek',
          iconPlacement: 'Ikonplacering',
        },
      },
      autoReply: {
        autoReplyTitle: 'Automatiskt svar',
        configureYour: 'Konfigurera ditt ',
        message: ' meddelande',
        customizeAutoReplyMessagesForYourPostsComments:
          'Anpassa automatiska svarmeddelanden för kommentarer på dina inlägg',
        wouldYouLikeToApply: 'Vill du tillämpa ',
        autoreply: 'Auto-Svar',
        onAllPost: ' på alla inlägg',
        configureYourMessageForEachPost: 'Konfigurera ditt meddelande för varje inlägg',
        configureFlowToTriggerAfterOnReply:
          'Konfigurera flöde för att triggas efter svar',
        whenUserLeavesACommentSendMessageAfter:
          'När användaren lämnar en kommentar, skicka meddelande efter',
        triggerFlowOnReply: 'Trigga flöde vid svar',
        add: 'Lägg till',
        update: 'Uppdatera',
        save: 'Spara',
        cancel: 'Avbryt',
        discard: 'Kasta bort',
        bpDropDown: {
          selectPost: 'Välj inlägg',
          triggerFlowOnReply: 'Trigga flöde vid svar',
          immendiately: 'Omedelbart',
          minutes: 'minuter',
        },
        bpTable: {
          message: 'Meddelande',
          selectedPost: 'Valt Inlägg',
          triggerFlow: 'Trigga Flöde',
          actions: 'Åtgärder',
        },
        placeholder: {
          configureYourMessage: 'Konfigurera ditt meddelande',
        },
        deleteModel: {
          title: 'Ta bort automatiskt svar på inlägg',
          description: 'Är du säker på att du vill ta bort detta automatiska svar på inlägg?',
        },
      },
      generalSetting: {
        sendInactivityMessage: 'Meddelande om användarinaktivitet',
        sessionTimeOutInHours: 'Session Timeout',
        enterSessionTimeOutWindowInHours:
          'Ange tidsfönster för sessionstimeout i timmar',
        sessionTimeOutInHoursTooltip: `Ange den tid efter vilken chattsessionen automatiskt kommer att timea ut
         på grund av inaktivitet. Chattflödet kommer att starta om om användaren skickar ett meddelande efter sessionstiden har gått ut.`,
        restartChatFlowTriggers: 'Starta om chattflödesutlösare',
        enterKeyWordsToRestartChatAndhitEnter:
          'Ange nyckelord för att starta om chatten och tryck på Enter',
        restartChatFlowTriggersTooltip: `Specificera nyckelord här som, när de skrivs in av användaren och skickas, kommer att utlösa en omstart av chattflödet. Detta gör att användare kan starta om konversationen när som helst.
        Tryck på Enter efter att ha lagt till varje nyckelord för att lägga till flera nyckelord.`,
        liveChatTriggers: 'Live-chattutlösare ',
        enterKeyWordsToTriggerLiveChatAndhitEnter:
          'Ange nyckelord för att utlösa live-chatt och tryck på Enter',
        liveChatTriggersTooltip: `Definiera nyckelord som, när de skrivs in av användaren och skickas, kommer att initiera en övergång från automatisk chatt till live-chatt. Detta är användbart när användare behöver hjälp från en
        liveagent. Tryck på Enter efter att ha lagt till varje nyckelord för att lägga till flera nyckelord.`,
        messageAfterAutomatedFlowCompleted:
          'Meddelande efter att automatiskt flöde har slutförts',
        enterYourMessage: 'Ange ditt meddelande',
        messageAfterAutomatedFlowCompletedTooltip: `Ange ett meddelande som kommer att visas för användaren efter att de har slutfört den automatiska
        chattflödet men sessionen har inte timeat ut.`,
        restart: 'Starta om',
        liveChat: 'Live-chatt',
        lineOneForDefaultMessage:
          'Om du har fler frågor eller behöver hjälp, här är vad du kan göra härnäst:',
        to: 'Till',
        restartTheChat: 'starta om chatten',
        simpleTypeRestartAndHitEnter: ` skriv helt enkelt 'Starta om' och tryck på Enter. Detta tar dig tillbaka till början av vår konversationsflöde.`,
        lineThreeForDefaultMessagePartOne: `Om du vill prata med en`,
        liveAgent: `live-agent,`,
        lineThreeForDefaultMessageLastPart: `skriv 'Live-chatt' och tryck på Enter. Vårt team är här för att hjälpa dig i realtid.`,
        saveChanges: 'Spara ändringar',
        discard: 'Kasta bort',
        configureBotsGeneralSettings: `Konfigurera din bots allmänna inställningar`,
        minutes: 'Minuter',
        hours: 'Timmar',
      },
    },
    instagram: {
      instagramBotSettings: 'Instagram Bot-inställningar',
      chatFlowsHeader: 'Chattflöden',
      broadcastHeader: 'Sändning',
      dripCampaignHeader: 'Drip-kampanj',
      widgetsHeader: 'Widgets',
      alertsHeader: 'Aviseringar',
      alerts: {
        configureYourBotsSettings: 'Konfigurera din bots avisinställningar',
        specifyHowYourBotNotifyYou:
          'Ange hur din bot kommer att meddela dig om nya leads.',
        subject: 'Ämne',
        emailNotification: 'E-postavisering',
        emailAddresses: 'E-postadresser',
        leadRevisitNotifications: 'Aviseringar för återbesök av lead',
        whenToSendLeadInfo: 'När ska Lead Info skickas',
        discard: 'Släng',
        saveChanges: 'Spara ändringar',
        placeholders: {
          enterSubjectForYourEmail: 'Ange ämne för din e-post',
          typeYourEmailAddressAndHitEnter:
            'Skriv in din e-postadress och tryck på Enter',
        },
      },
      broadcasts: {
        createBroadcast: 'Skapa sändning',
        youCanCreateMultipleBroadcasts: 'Du kan skapa flera sändningar',
        broadcastName: 'Sändningsnamn',
        broadcastNameIsRequired: 'Sändningsnamn krävs',
        continue: 'Fortsätt',
        manageBroadcasts: 'Hantera sändningar',
        youCanCreateMultipleBroadcastsWithMultipleTemplatesAndDifferentSegments:
          'Du kan skapa flera sändningar med flera' +
          ' schemalagda mallar för olika kundgrupper.',
        createNewBroadcast: 'Skapa ny sändning',
        segment: 'Grupp',
        template: 'Mall',
        contacts: 'Kontakter',
        send: 'Skicka',
        failed: 'Misslyckades',
        broadcastAt: 'Sänd vid',
        status: 'Status',
        actions: 'Åtgärder',
        nA: 'NA',
        placeholders: {
          enterBroadcastName: 'Ange sändningsnamn',
          searchHere: 'Sök här',
        },
        appTooltip: {
          deleteMultipleBroadcasts: 'Radera flera sändningar',
          deleteBroadcast: 'Radera sändning',
        },
      },
      createBroadcast: {
        broadcastName: 'Sändningsnamn',
        broadcastNameIsRequired: 'Sändningsnamn krävs',
        flow: 'Flöde',
        segments: 'Grupper',
        whenToSend: 'När ska det sändas',
        selectDate: 'Välj datum',
        selectTimeSlot: 'Välj tidsintervall',
        cancel: 'Avbryt',
        createBroadcast: 'Skapa sändning',
        placeholders: {
          enterBroadcastName: 'Ange sändningsnamn',
          selectFlow: 'Välj flöde',
          searchFlowByName: 'Sök efter flöde efter namn',
          selectSegments: 'Välj grupper',
          searchSegmentByName: 'Sök efter grupp efter namn',
          selectTimeSlot: 'Välj tidsintervall',
        },
        indexMergeDatePicker: {
          selectStartDate: 'Välj startdatum',
        },
      },
      dripCampaigns: {
        createDripCampaign: 'Skapa drip-kampanj',
        youCanCreateMultipleCampaigns: 'Du kan skapa flera kampanjer',
        dripCampaignName: 'Drip-kampanjens namn',
        dripCampaignNameIsRequired: 'Drip-kampanjens namn krävs',
        continue: 'Fortsätt',
        manageDripCampaign: 'Hantera drip-kampanj',
        youCanCreateMultipleCampaignsWith:
          'Du kan skapa flera drip-kampanjer med schemalagda, automatiska meddelanden för att' +
          ' trigga svar från specifika användargrupper.',
        createNewDripCampaign: 'Skapa ny drip-kampanj',
        campaignName: 'Kampanjens namn',
        appliedOn: 'Tillämpad på',
        segment: 'Grupp',
        flow: 'Flöde',
        startDate: 'Startdatum',
        action: 'Åtgärd',
        nA: 'NA',
        placeholders: {
          enterDripCampaignName: 'Ange drip-kampanjens namn',
          searchByName: 'Sök efter namn',
        },
        appTooltip: {
          deleteMultipleDripCampaigns: 'Radera flera drip-kampanjer',
          deleteDripCampaign: 'Radera drip-kampanj',
        },
        createDripCampaignInstagram: {
          dripCampaignName: 'Drip-kampanjens namn',
          appliedOn: 'Tillämpad på',
          segments: 'Grupper',
          selectDate: 'Välj datum',
          scheduleYourFlows: 'Schemalägg dina flöden',
          flow: 'Flöde',
          sendAfter: 'Skicka efter',
          cancel: 'Avbryt',
          createDripCampaign: 'Skapa drip-kampanj',
          placeholders: {
            enterDripName: 'Ange drip-namn',
            selectAppliedOn: 'Välj Tillämpad på',
            selectSegment: 'Välj grupp',
            searchByName: 'Sök efter namn',
            selectTemplate: 'Välj mall',
            searchFlowByName: 'Sök efter flöde efter namn',
            enterSendAfter: 'Ange skicka efter',
          },
          dateTimePicker: {
            selectStartDate: 'Välj startdatum',
          },
        },
      },
      failedBroadcastInstagram: {
        chatId: 'Chatt ID',
        errorCode: 'Felkod',
        errorMessage: 'Felmeddelande',
        nA: 'NA',
      },
      flows: {
        chatFlows: 'Chattflöden',
        createChatFlow: 'Skapa chattflöde',
        youCanCreateMultipleChatFlows:
          'Du kan skapa flera konversationsflöden över flera kanaler för A/B-testning och sändningar.',
        flowName: 'Flödesnamn',
        nameIsRequired: 'Namn krävs',
        cancel: 'Avbryt',
        createFlow: 'Skapa flöde',
        importFlow: 'Importera flöde',
        createNewFlow: 'Skapa nytt flöde',
        // flowName: 'Flödesnamn'
        ofMessages: ' av meddelanden',
        createdOn: 'Skapad den',
        lastModified: 'Senast ändrad',
        defaultFlow: 'Standardflöde',
        action: 'Åtgärd',
        exportStatus: 'Exportstatus',
        flowExport: 'Flödesexport ',
        download: 'Ladda ner',
        // importFlow: 'Importera flöde',
        beforeYouStartUploadPleaseMakeSure:
          'Innan du börjar ladda upp, se till att',
        point1: '1. Den maximala filstorleken för uppladdningsgränsen är 20 MB',
        point2: '2. Filformatet ska vara i JSON',
        selectFile: 'Välj fil',
        placeholders: {
          enterFlowName: 'Ange flödesnamn',
        },
        appTooltip: {
          importFlowForInstagramBot: 'Importera flöde för Instagram-bot',
          dateAndTimeOfCreationOfChatFlow:
            'Datum och tid för skapande av chattflöde',
          dateAndTimeWhenChatFlowLastModified:
            'Datum och tid när chattflödet senast ändrades',
        },
        noDataFound: {
          flows: 'Flöden',
          noFlowsAddedYet: 'Inga flöden har lagts till ännu!',
        },
        modal: {
          deleteFlow: 'Radera flöde',
          wantToDeleteThisFlow: 'Är du säker på att du vill radera detta flöde?',
        },
      },
      widgets: {
        manageWidgets: 'Hantera widgets',
        widgetsAreRoutingTools:
          'Widgets är riktningsverktyg för att öka användningen av bot',
        needHelp: 'Behöver du hjälp?',
        wantToMakeChanges: 'Vill du göra ändringar?',
        editIcon: 'Redigera ikon',
        discard: 'Släng',
        updateWidget: 'Uppdatera widget',
        bpDropDown: {
          selectIcons: 'Välj ikoner',
          iconSize: 'Ikonstorlek',
          iconPlacement: 'Ikonplacering',
        },
      },
    },
    telegram: {
      telegramBotSettings: 'Inställningar för Telegram-bot',
      chatFlowsHeader: 'Chattflöden',
      telegramProfileHeader: 'Telegramprofil',
      widgetsHeader: 'Widgets',
      broadcastHeader: 'Sändning',
      dripCampaignHeader: 'Drip-kampanj',
      generalHeader: 'Allmänt',
      telegramAutomation: 'Telegram Automation',
      appTooltip: {
        TOOLTIP_DRIP_CAMPAIGN_TITLE:
          'Skapa en kundinförlivningsresa med hjälp av en drip-kampanj av schemalagda chattflöden.',
        TOOLTIP_CHAT_FLOW_TITLE:
          'Anpassa chattflödesmallarna och skapa flera chattflöden för olika målgrupper.',
      },
      broadcasts: {
        createBroadcast: 'Skapa sändning',
        youCanCreateMutlipleBroadcasts: 'Du kan skapa flera sändningar',
        broadcastName: 'Sändningsnamn',
        broadcastNameIsRequired: 'Sändningsnamn krävs',
        continue: 'Fortsätt',
        manageBroadcasts: 'Hantera sändningar',
        youCanCreateMultipleBroadcastsWith:
          'Du kan skapa flera sändningar med flera schemalagda mallar för olika kundgrupper.',
        createNewBroadcast: 'Skapa ny sändning',
        name: 'Namn',
        segment: 'Grupp',
        template: 'Mall',
        contacts: 'Kontakter',
        send: 'Skicka',
        failed: 'Misslyckades',
        broadcastAt: 'Sänd vid',
        status: 'Status',
        actions: 'Åtgärder',
        nA: 'NA',
        deleteBroadcast: 'Radera sändning',
        wantToDeleteThisBroadcast:
          'Är du säker på att du vill radera denna sändning?',
        placeholders: {
          enterBroadcastName: 'Ange sändningsnamn',
          searchHere: 'Sök här',
        },
        appTooltip: {
          deleteMultipleBroadcasts: 'Radera flera sändningar',
          deleteBroadcast: 'Radera sändning',
        },
      },
      createBroadcastTelegram: {
        broadcastName: 'Sändningsnamn',
        broadcastNameIsRequired: 'Sändningsnamn krävs',
        flow: 'Flöde',
        segments: 'Grupper',
        whenToSend: 'När ska det sändas',
        selectDate: 'Välj datum',
        selectTimeSlot: 'Välj tidsintervall',
        cancel: 'Avbryt',
        createBroadcast: 'Skapa sändning',
        now: 'Nu',
        later: 'Senare',
        placeholders: {
          enterBroadcastName: 'Ange sändningsnamn',
          selectFlow: 'Välj flöde',
          searchFlowByName: 'Sök efter flöde efter namn',
          selectSegments: 'Välj grupper',
          searchSegmentByName: 'Sök efter grupp efter namn',
          selectTimeSlot: 'Välj tidsintervall',
        },
        indexMergeDatePicker: {
          selectStartDate: 'Välj startdatum',
        },
      },
      dripCampaigns: {
        createDripCampaign: 'Skapa drip-kampanj',
        youCanCreateMultipleCampaigns: 'Du kan skapa flera kampanjer',
        dripCampaignName: 'Drip-kampanjens namn',
        dripCampaignNameIsRequired: 'Drip-kampanjens namn krävs',
        continue: 'Fortsätt',
        manageDripCampaign: 'Hantera drip-kampanj',
        youCanCreateMultipleDripCampaignsWith:
          'Du kan skapa flera drip-kampanjer med schemalagda, automatiska meddelanden' +
          ' för att trigga svar från specifika användargrupper.',
        createNewDripCampaign: 'Skapa ny drip-kampanj',
        campaignName: 'Kampanjens namn',
        appliedOn: 'Tillämpad på',
        segment: 'Grupp',
        flow: 'Flöde',
        startDate: 'Startdatum',
        action: 'Åtgärd',
        nA: 'NA',
        deleteDripCampaign: 'Radera drip-kampanjer',
        wantToDeleteThisDripCampaign:
          'Är du säker på att du vill radera denna drip-kampanj?',
        placeholders: {
          enterDripCampaignName: 'Ange drip-kampanjens namn',
          searchByName: 'Sök efter namn',
        },
        appTooltip: {
          deleteMultipleDripCampaigns: 'Radera flera drip-kampanjer',
          deleteDripCampaign: 'Radera drip-kampanj',
        },
        createDripCampaignTelegram: {
          dripCampaignName: 'Drip-kampanjens namn',
          appliedOn: 'Tillämpad på',
          segments: 'Grupper',
          startDate: 'Välj datum',
          scheduleYourFlows: 'Schemalägg dina flöden',
          schedule: 'Schema',
          flow: 'Flöde',
          sendAfter: 'Skicka efter',
          cancel: 'Avbryt',
          createDripCampaign: 'Skapa drip-kampanj',
          newSubscriber: 'Ny prenumerant',
          days: 'Dagar',
          minutes: 'Minuter',
          hours: 'Timmar',
          placeholders: {
            enterDripName: 'Ange drip-namn',
            selectAppliedOn: 'Välj Tillämpad på',
            selectSegment: 'Välj grupp',
            searchByName: 'Sök efter namn',
            selectFlow: 'Välj flöde',
            searchFlowByName: 'Sök efter flöde efter namn',
          },
          dateTimePicker: {
            selectStartDate: 'Välj startdatum',
          },
        },
      },
      failedBroadcastTelegram: {
        name: 'Namn',
        email: 'E-post',
        phone: 'Telefon',
        errorCode: 'Felkod',
        errorMessage: 'Felmeddelande',
        nA: 'NA',
      },
      flows: {
        chatFlows: 'Chattflöden',
        createChatFlow: 'Skapa chattflöde',
        youCanCreateMultipleChatFlows:
          'Du kan skapa flera konversationsflöden över flera kanaler för A/B-testning och sändningar.',
        flowName: 'Flödesnamn',
        nameIsRequired: 'Namn krävs',
        cancel: 'Avbryt',
        createFlow: 'Skapa flöde',
        importFlow: 'Importera flöde',
        createNewFlow: 'Skapa nytt flöde',
        // flowName: 'Flödesnamn',
        ofMessages: ' av meddelanden',
        createdOn: 'Skapad den',
        lastModified: 'Senast ändrad',
        defaultFlow: 'Standardflöde',
        action: 'Åtgärd',
        exportStatus: 'Exportstatus',
        flowExport: 'Flöde-export ',
        inProgress: 'Pågår',
        available: 'Tillgänglig',
        initiated: 'Initierad',
        download: 'Ladda ner',
        // importFlow: 'Importera flöde',
        beforeYouStartUploadPleaseMakeSure:
          'Innan du börjar ladda upp, se till att',
        point1: '1. Den maximala filstorleken är 20 MB',
        point2: '2. Filformatet ska vara JSON',
        selectFile: 'Välj fil',
        placeholders: {
          enterFlowName: 'Ange flödesnamn',
        },
        appTooltip: {
          importFlowForTelegramBot: 'Importera flöde för Telegram-bot',
          dateAndTimeOfCreationOfChatFlow:
            'Datum och tid för skapande av chattflödet',
          dateAndTimeWhenChatFlowLastModified:
            'Datum och tid för senaste ändringen av chattflödet',
          TOOLTIP_CREATE_FLOW: 'Klicka för att skapa ett nytt chattflöde',
          TOOLTIP_FLOW_NAME: 'Ange namn på chattflödet',
          TOOLTIP_FLOW_TABLE_NAME: 'Namn på chattflödet',
          TOOLTIP_NO_OF_MESSAGES: 'Antal meddelandekomponenter i chattflödet',
          TOOLTIP_DEFAULT_FLOW:
            'Använd denna växel för att ställa in ett chattflöde som standard, som kommer att serveras till alla nya användare.',
          TOOLTIP_ACTION: 'Redigera eller radera chattflödet',
        },
        noDataFound: {
          flows: 'Flöden',
          noFlowsAddedYet: 'Inga flöden har lagts till ännu!',
        },
        modal: {
          deleteFlow: 'Radera flöde',
          wantToDeleteThisFlow: 'Är du säker på att du vill radera detta flöde?',
        },
      },
      telegramProfile: {
        telegramProfile: 'Telegramprofil',
        manageYourBotProfile: 'Hantera din botprofil när du vill.',
        allSetNoActionRequired: 'Allt klart, ingen åtgärd krävs!',
        congratulationYourAccountIsLive:
          'Grattis! Ditt konto är aktivt med full tillgång',
        botDetails: 'Botdetaljer',
        name: 'Namn',
        nA: 'NA',
        b: 'B',
        botName: 'Botnamn',
        bot: 'Bot',
        info: 'Info',
        none: 'Ingen',
        username: 'Användarnamn',
        notifications: 'Aviseringar',
        on: 'På',
        addToGroupOrChannel: 'Lägg till i grupp eller kanal',
        userName: 'Användarnamn',
        botToken: 'Bot-token',
      },
      widgets: {
        manageWidgets: 'Hantera widgets',
        widgetsAreRoutingTools:
          'Widgets är routingverktyg för att öka användningen av boten',
        needHelp: 'Behöver hjälp?',
        wantToMakeChanges: 'Vill du göra ändringar?',
        editIcon: 'Redigera ikon',
        discard: 'Släng',
        updateWidget: 'Uppdatera widget',
        installChatBotIconOnYourWebsite: 'Installera chatbot-ikon på din webbplats',
        shareWhereEverYouWantRedirectUsersTo:
          'Dela var du vill och omdirigera användare till din Telegram-bot med ett klick',
        copyAndAddInYourWebsiteHeaderFile:
          'Kopiera och lägg till i din webbplats header-fil',
        copyLinkAndStartSharing: 'Kopiera länk och börja dela!',
        downloadQrCodeAndStartSharing: 'Ladda ner QR-kod och börja dela!',
        addCodeAndDeployNewCodeAndDone:
          'Lägg till koden, implementera ny kod och klart!',
        wantToLearnHowToUseIt: 'Vill du lära dig hur man använder det?',
        copyChatBotCode: 'Kopiera Chatbot-kod',
        downloadQrCode: 'Ladda ner QR-kod',
        copyTelegramLink: 'Kopiera Telegram-länk',
        link: 'Länk',
        chatBotIcon: 'Chatbot-ikon',
        qrcode: 'QR-kod',
        small: 'Liten',
        medium: 'Medium',
        large: 'Stor',
        leftMiddle: 'Vänster-mitten',
        rightMiddle: 'Höger-mitten',
        leftBottom: 'Vänster-nedre',
        rightBottom: 'Höger-nedre',
        bpDropDown: {
          selectIcons: 'Välj ikoner',
          iconSize: 'Ikonstorlek',
          iconPlacement: 'Ikonplacering',
        },
      },
      generalSetting: {
        sendInactivityMessage: 'Meddelande om användarinaktivitet',
        sessionTimeOutInHours: 'Session Time Out',
        enterSessionTimeOutWindowInHours:
          'Ange fönster för sessionstimeout i timmar',
        sessionTimeOutInHoursTooltip: `Ange den tid efter vilken chattsessionen automatiskt kommer att löpa ut
         på grund av inaktivitet. Chattflödet startar om om användaren skickar ett meddelande efter timeouten`,
        restartChatFlowTriggers: 'Starta om Chattflödesutlösare',
        enterKeyWordsToRestartChatAndhitEnter:
          'Ange sökord för att starta om chatt och tryck på Enter',
        restartChatFlowTriggersTooltip: `Specificera sökord här som, när de anges av användaren och skickas in, kommer att utlösa en omstart av chattflödet. Detta gör det möjligt för användare att starta om konversationsflödet när som helst.
        Tryck på Enter efter att ha lagt till varje sökord för att lägga till flera sökord.`,
        liveChatTriggers: 'Starta Live Chatt-utlösare ',
        enterKeyWordsToTriggerLiveChatAndhitEnter:
          'Ange sökord för att starta livechatt och tryck på Enter',
        liveChatTriggersTooltip: `Definiera sökord som, när de anges av användaren och skickas in, kommer att initiera en övergång från automatisk chatt till livechatt. Detta är användbart när användare behöver hjälp från en l
        iveagent. Tryck på Enter efter att ha lagt till varje sökord för att lägga till flera sökord.`,
        messageAfterAutomatedFlowCompleted:
          'Meddelande efter att det automatiska flödet är klart',
        enterYourMessage: 'Ange ditt meddelande',
        messageAfterAutomatedFlowCompletedTooltip: `Ange ett meddelande som kommer att visas för användaren efter att de har slutfört det automatiska
        chattflödet men sessionen har inte löpt ut.`,
        restart: 'Starta om',
        liveChat: 'Live chatt',
        lineOneForDefaultMessage:
          'Om du har fler frågor eller behöver hjälp, här är vad du kan göra nästa:',
        to: 'Till',
        restartTheChat: 'starta om chatten',
        simpleTypeRestartAndHitEnter: ` skriv helt enkelt 'Starta om' och tryck på Enter. Detta tar dig tillbaka till början av vår konversationsflöde.`,
        lineThreeForDefaultMessagePartOne: `Om du vill prata med en`,
        liveAgent: `liveagent,`,
        lineThreeForDefaultMessageLastPart: `skriv 'Live chatt' och tryck på Enter. Vårt team är här för att hjälpa dig i realtid.`,
        saveChanges: 'Spara ändringar',
        discard: 'Släng',
        configureBotsGeneralSettings: `Konfigurera din bots allmänna inställningar`,
        minutes: 'Minuter',
        hours: 'Timmar',
      },
    },
    whatsapp: {
      whatsappAutomation: 'WhatsApp-automation',
      whatsappBotSettings: 'Whatsapp Bot-inställningar',
      generalHeader: 'Allmänt',
      chatFlowsHeader: 'Chattflöden',
      whatsappProfileHeader: 'WhatsApp-profil',
      broadcastHeader: 'Sändning',
      dripCampaignHeader: 'Drip-kampanj',
      widgetHeader: 'Widget',
      templatesHeader: 'Mallar',
      alertsHeader: 'Aviseringar',
      apiKeyHeader: 'API-nyckel',
      catalogHeader: 'Katalog',
      otherConfiguration: 'AI-inställningar',
      appTooltip: {
        TOOLTIP_CHAT_FLOW_TITLE:
          'Anpassa chattflödesmallarna och skapa flera chattflöden för olika målgrupper.',
      },
      alerts: {
        configureYourBotsAlertSettings: `Konfigurera din bots avisinställningar`,
        specifyHowYouBotWillNotify:
          'Ange hur din bot ska meddela dig om nya leads.',
        subject: 'Ämne',
        emailNotification: 'E-postavisering',
        emailAddresses: 'E-postadresser',
        leadRevisitNotifications: 'Aviseringar om återbesök av lead',
        whenToSendLeadInfo: 'När ska leadinfo skickas',
        discard: 'Kasta',
        saveChanges: 'Spara ändringar',
        seeHowToUse: 'Se hur du använder',
        beginningTheFlow: 'Början av flödet',
        fiveMinutesLater: '5 minuter senare',
        endOfFlow: 'Slutet av flödet',
        placeholders: {
          enterSubjectForYourEmail: 'Ange ämne för din e-post',
          typeEmailAndHitEnter: 'Skriv din e-postadress och tryck på enter',
        },
        appTooltip: {
          TOOLTIP_SUBJECTS:
            'Anpassa ämnet för dina e-postaviseringar från botten',
          TOOLTIP_EMAIL_NOTIFICATION:
            'Aktivera/inaktivera bottens avisering på din e-post för nya leads',
          TOOLTIP_EMAIL_ADDRESS:
            'Ange e-postadressen för det konto där du vill ta emot e-postaviseringar. Du kan lägga till flera e-postadresser genom att ange en och trycka på enter för att lägga till en annan.',
          TOOLTIP_LEAD_REVISIT_NOTIFICATION:
            ' Aktivera/inaktivera bottenavisering på din e-post om en användare som tidigare registrerats som lead interagerar med botten igen.',
        },
      },
      editProfile: {
        updateWhatsappChatBot: 'Uppdatera WhatsApp Chatbot',
        businessNameIsRequired: 'Företagsnamn krävs.',
        maxLengthForBusinessName40Characters:
          'Maximal längd för företagsnamn är 40 tecken.',
        categoryIsRequired: 'Kategori krävs.',
        descriptionIsRequired: 'Beskrivning krävs.',
        maxLengthForDescription200Characters:
          'Maximal längd för beskrivning är 200 tecken.',
        aboutIsRequired: 'Om krävs.',
        maxLengthForAbout139Characters:
          'Maximal längd för om är 139 tecken.',
        pleaseFillAValidBusinessEmail: 'Fyll i en giltig affärse-post.',
        businessEmailIsRequired: 'Företagse-post krävs.',
        websiteIsRequired: 'Webbplats krävs.',
        maxLengthForWebsite40Characters:
          'Maximal längd för webbplatsen är 40 tecken.',
        maxLengthForAddress150Characters:
          'Maximal längd för adressen är 150 tecken.',
        cancel: 'Avbryt',
        update: 'Uppdatera',
        businessCategory: 'Företagskategori',
        placeholders: {
          yourBusinessName: 'Ditt företagsnamn',
          businessDescription: 'Företagsbeskrivning',
          about: 'Om',
          businessEmail: 'Företagse-post',
          website: 'Webbplats (t.ex. www.example.com)',
          address: 'Adress',
        },
      },
      flows: {
        chatFlows: 'Chattflöden',
        createChatFlow: 'Skapa Chattflöde',
        youCanCreateMultipleChatFlows:
          'Du kan skapa flera konversationsflöden över flera kanaler för A/B-testning och sändningar.',
        flowName: 'Flödesnamn',
        nameIsRequired: 'Namn krävs',
        cancel: 'Avbryt',
        createFlow: 'Skapa Flöde',
        importFlow: 'Importera Flöde',
        createNewFlow: 'Skapa Nytt Flöde',
        ofMessages: ' av meddelanden',
        createdOn: 'Skapad den',
        lastModified: 'Senast ändrad',
        defaultFlow: 'Standardflöde',
        revisitFlow: 'Återbesökflöde',
        action: 'Åtgärd',
        exportStatus: 'Exportstatus',
        flowExport: 'Flödesexport',
        beforeYouStartUploadPleaseMakeSure:
          'Innan du börjar ladda upp, se till att',
        point1: '1. Den maximala filstorleksgränsen är 20 MB',
        point2: '2. Filformatet ska vara i JSON',
        selectFile: 'Välj Fil',
        seeHowToUse: 'Se hur du använder',
        download: 'Ladda ner',
        available: 'Tillgänglig',
        initiated: 'Initierad',
        inProgress: 'Pågår',
        placeholders: {
          enterFlowName: 'Ange flödesnamn',
        },
        appTooltip: {
          importFlowForWhatsappBot: 'Importera flöde för Whatsapp-bot',
          dateAndTimeOfCreationOfChatFlow:
            'Datum och tid för skapandet av chattflödet',
          dateAndTimeWhenChatFlowLastModified:
            'Datum och tid när chattflödet senast ändrades',
          TOOLTIP_CREATE_FLOW: 'Klicka för att skapa ett nytt chattflöde',
          TOOLTIP_FLOW_NAME: 'Ange chattflödets namn',
          TOOLTIP_FLOW_TABLE_NAME: 'Namn på chattflödet',
          TOOLTIP_NO_OF_MESSAGES: 'Antal meddelandekomponenter i chattflödet',
          TOOLTIP_DEFAULT_FLOW:
            'Använd den här omkopplaren för att ställa in ett chattflöde som standard, som kommer att serveras för alla nya användare.',
          TOOLTIP_REVISIT_FLOW:
            'Använd den här omkopplaren för att välja ett chattflöde som ska serveras för användare när de återvänder till din chattbot.',
          TOOLTIP_ACTION: 'Redigera eller ta bort chattflödet',
        },
        modal: {
          deleteFlow: 'Ta bort flöde',
          wantToDeleteThisFlow: 'Är du säker på att du vill ta bort detta flöde?',
        },
        noDataFound: {
          flows: 'Flöden',
          noFlowsAddedYet: 'Inga flöden tillagda ännu!',
        },
      },
      input: {
        manageTemplates: 'Hantera Mallar',
        manageYourTemplatesForMarketingAutomation:
          'Hantera dina mallar för marknadsautomation',
        syncTemplates: 'Synkronisera Mallar',
        createTemplateHeader: 'Skapa Mall',
        title: 'Titel',
        info: 'Info',
        category: 'Kategori',
        status: 'Status',
        action: 'Åtgärd',
        shipmentUpdate: 'Leveransuppdatering',
        name: 'Namn',
        // category: 'Kategori',
        headerOptional: 'Rubrik (Valfri)',
        bodyRequired: 'Brödtext (obligatorisk)',
        footerOptional: 'Sidfot (Valfri)',
        buttonsOptional: 'Knappar (Valfritt)',
        makeUpto3Buttons: 'Skapa upp till 3 knappar',
        makeUpto2ButtonsToRedirect:
          'Skapa upp till 2 knappar för att omdirigera kunden till din webbplats',
        placeholders: {
          nameYourTemplate:
            'Namnge din mall (använd understreck för att separera ord)',
          enterText: 'Ange text (max 60 tecken)',
          enterImageUrl: 'Ange bild-URL',
          enterVideoUrl: 'Ange video-URL',
          templateMessage: 'Mallmeddelande',
          smallFooterAtBottom: 'Liten sidfot längst ner',
          buttons: 'Knappar',
          text: 'Text',
          numberWithCountryCode: 'Nummer med landskod',
          enterButtonText: 'Ange knappens text (max 20 tecken)',
        },
        appTooltip: {
          TOOLTIP_INPUT_TABLE_TITLE: 'Namn på WhatsApp-mallen',
          TOOLTIP_INPUT_TABLE_INFO:
            'Detaljerad information om de affärsinitierade meddelandena',
          TOOLTIP_INPUT_TABLE_CATEGORY:
            'Typ av affärsinitierade meddelanden som möten, påminnelser, ' +
            'kundvårdsmeddelanden, uppdateringar om frakt, varningar och mer',
          TOOLTIP_INPUT_TABLE_STATUS:
            'Mallstatusen avvisas eller godkänns av Whatsapp. Whatsapp-mallar ' +
            'måste först godkännas av Whatsapp och detta är en betaltjänst.',
          TOOLTIP_INPUT_TABLE_ACTIONS: 'Ta bort mallen',
        },
        noDataFound: {
          templates: 'Mallar',
          noTemplatesCreatedYet: 'Inga mallar skapade ännu!',
        },
        modal: {
          deleteTemplate: 'Ta bort mall',
          wantToDeleteThisTemplate: 'Är du säker på att du vill ta bort denna mall?',
        },
        createTemplate: {
          createTemplates: 'Skapa Mallar',
          createTemplatesForMarketingAutomation:
            'Skapa dina mallar för marknadsautomation',
          templateMeta: 'Mallmeta',
          selectLanguage: 'Välj språk',
          header: 'Rubrik',
          optional: 'Valfri',
          samplesForHeaderContent: 'Exempel på innehåll i rubriken',
          toHelpMetaReviewYourContent:
            'För att hjälpa meta granska ditt innehåll, ange exempel på variablerna ' +
            'eller medier i rubriken. Inkludera inte någon kundinformation.',
          body: 'Brödtext',
          addVariable: 'Lägg till variabel',
          samplesForBodyContent: 'Exempel på innehåll i brödtexten',
          toHelpUsReviewYourContent:
            'För att hjälpa oss granska ditt innehåll, ange exempel på variablerna i' +
            'brödtexten. Inkludera inte någon kundinformation.',
          footer: 'Sidfot',
          // optional: 'Valfri',
          buttons: 'Knappar',
          // optional: 'Valfri',
          typeOfAction: 'Typ av åtgärd',
          call: 'Ring',
          phone: 'Telefon',
          website: 'Webbplats',
          static: 'Statisk',
          urlType: 'URL-typ',
          type: 'Typ',
          customButton: 'Anpassad knapp',
          addAnotherButton: 'Lägg till en annan knapp',
          preview: 'Förhandsvisning',
          test: 'Testa',
          create: 'Skapa',
          addSampleUrl: 'Lägg till exempel-URL',
          toHelpMetaReviewYourMessage:
            'För att hjälpa meta granska din meddelandemall, lägg till ett exempel på webbplatsens ' +
             'URL. Använd inte verklig kundinformation.',
          placeholders: {
            enterMessageTemplateName: 'Ange meddelandemallens namn',
            searchTemplateByName: 'Sök mall efter namn',
            selectTemplate: 'Välj mall',
            enterText: 'Ange text',
            enterBody: 'Ange brödtext',
            enterContentForVariable: 'Ange innehåll för variabel',
            enterFooter: 'Ange sidfot',
            phone: 'Telefon*',
            enterWebsiteUrl: 'Ange webbplatsens URL',
          },
          bpInput: {
            name: 'Namn',
            buttonText: 'Knappens text',
            websiteUrl: 'Webbplatsens URL',
          },
          bpDropDown: {
            selectCategory: 'Välj kategori',
          },
        },
        templatePreview: {
          preview: 'Förhandsvisning',
          test: 'Testa',
        },
        templateConfig: {
          saveChanges: 'Spara ändringar',
          discard: 'Förkasta',
          triggerChatFlowOnTemplateReply: 'Utlösa chattflöde vid mallens svar',
          templateDetails: 'Mallinformation',
          configureFlows: 'Konfigurera flöden',
          selectFlow: 'Välj flöde',
          name: 'Namn',
        },
      },
      shopManagement: {
        shopManagement: 'Butikshantering',
        manageECommerceShopFromBotPenguin:
          'Hantera e-handelsbutiker som är anslutna till BotPenguin',
        comingSoon: '( Kommer snart )',
        wooCommerce: {
          createConfiguration: 'Skapa konfiguration',
          eventConfiguration: {
            createConfiguration: 'Skapa konfiguration',
            templateHeader: 'Mallhuvud',
            selectFile: 'Välj fil',
            templateMessage: 'Mallmeddelande',
            saveChanges: 'Spara ändringar',
            bpDropDown: {
              selectEvent: 'Välj händelse',
              selectTemplate: 'Välj mall',
            },
          },
        },
      },
      whatsappProfile: {
        whatsappProfile: 'WhatsApp-profil',
        manageYourBotProfile: 'Hantera din botprofil när du vill.',
        allSetNoActionRequired: 'Allt klart, ingen åtgärd krävs!',
        congratulationsYourAccountIsLive:
          'Grattis! Ditt konto är live med fullständig åtkomst',
        somethingIsWrongReactivateYourBot:
          'Något är fel, återaktivera din bot!',
        itSeemsLikeYourBotIsNotWorkingProperly:
          'Det verkar som att din bot inte fungerar korrekt, återställ din bot',
        reConfigureYourBot: 'Konfigurera om din bot',
        phoneNumberDetails: 'Telefonnummerdetaljer',
        phoneNumber: 'Telefonnummer',
        nA: 'NA',
        phoneNumberId: 'Telefonnummer-ID',
        wabaId: 'WABA ID',
        change: 'Ändra',
        accessToken: 'Åtkomsttoken',
        // change: 'Ändra',
        messagingLimit: 'Meddelandegräns',
        qualityRating: 'Kvalitetsbetyg',
        whatsappBusinessAccountName: 'WhatsApp Business-kontonamn',
        whatsappPublicProfile: 'WhatsApp offentlig profil',
        profilePicture: 'Profilbild',
        aboutText: 'Om text',
        address: 'Adress',
        description: 'Beskrivning',
        email: 'E-post',
        websitePrimary: 'Webbplats (Primär)',
        websiteSecondary: 'Webbplats (Sekundär)',
        businessVertical: 'Företagsvertikal',
        editProfile: 'Redigera profil',
        thisIsABusinessAccount: 'Detta är ett affärskonto',
        aboutAndPhoneNumber: 'Om och telefonnummer',
        yourTrialAccountIsLive:
          'Grattis! Ditt testkonto är live med fullständig åtkomst på ditt verifierade nummer',
        updateWithNewAccessToken: 'Uppdatera med ny åtkomsttoken',
      },
      widgets: {
        manageWidgets: 'Hantera widgets',
        widgetsAreRoutingTools:
          'Widgets är routingsverktyg för att öka användningen av boten',
        needHelp: 'Behöver hjälp?',
        wantToMakeChanges: 'Vill du göra ändringar?',
        prePopulatedMessage: 'Förifylldt meddelande',
        discard: 'Släng',
        updateWidget: 'Uppdatera widget',
        hiThere: 'Hej där ',
        seeHowToUse: 'Se hur man använder',
        editIcon: 'Redigera ikon',
        editPrePopulatedMessage: 'Redigera förifyllt meddelande',
        small: 'Liten',
        medium: 'Medium',
        large: 'Stor',
        leftMiddle: 'Vänster-Mitte',
        rightMiddle: 'Höger-Mitte',
        leftBottom: 'Vänster-Nederkant',
        rightBottom: 'Höger-Nederkant',
        chatBotIcon: 'Botikon',
        link: 'Länk',
        qrcode: 'QR-kod',
        copyChatBotCode: 'Kopiera Chatbot-kod',
        copyWALink: 'Kopiera WA-länk',
        downloadQrCode: 'Ladda ner QR-kod',
        installChatBotIconOnYourWebsite: 'Installera chattbotikon på din webbplats',
        shareWhereEverYouWantRedirectUsersTo:
          'Dela var du vill och omdirigera användare till din WhatsApp-bot med ett enda klick',
        copyAndAddInYourWebsiteHeaderFile:
          'Kopiera och lägg till i din webbplats headerfil',
        copyLinkAndStartSharing: 'Kopiera länken och börja dela!',
        downloadQrCodeAndStartSharing: 'Ladda ner QR-koden och börja dela!',
        addCodeAndDeployNewCodeAndDone:
          'Lägg till koden, distribuera ny kod och klart!',
        wantToLearnHowToUseIt: 'Vill du lära dig hur man använder det?',
        placeholders: {
          enterWhatsappNumber: 'Ange WhatsApp-nummer',
          updateYourMessageHere: 'Uppdatera ditt meddelande här...',
        },
        bpDropDown: {
          selectIcons: 'Välj ikoner',
          iconSize: 'Ikonstorlek',
          iconPlacement: 'Ikonplacering',
        },
        bpInput: {
          whatsappNumber: 'WhatsApp-nummer',
        },
      },
      catalog: {
        createCatalog: 'Skapa Katalog',
        createProductCatalogOnTheMetaCommerceManagerOrLinkItWithShopify:
          'Skapa produktkatalog på Meta Commerce Manager eller länka den med Shopify',
        useYourMetaCommerceManagertoManageCatalogs:
          'Använd din Meta commerce manager för att hantera kataloger',
        connectCatalogToWhatsAppAccount:
          'Anslut katalogen till WhatsApp-kontot',
        connectYourCatalogsToWhatsAppAccountUsingYourWhatsAppManager:
          'Anslut dina kataloger till WhatsApp-kontot med hjälp av din WhatsApp-manager',
        useYourMetaWhatsAppManagerToConnectCatalogsAndUsethemWithBotPenguin:
          'Använd din Meta WhatsApp-manager för att ansluta kataloger och använda dem med BotPenguin',
        goToMeta: 'Gå till Meta',
        goToShopify: 'Gå till Shopify',
        next: 'Nästa',
        back: 'Tillbaka',
        setupCatalog: 'Konfigurera katalog',
        completeAllTheStepsToEnableCatalogMessages:
          'Slutför alla steg för att aktivera katalogmeddelanden',
      },
      generalSetting: {
        sendInactivityMessage: 'Användarinaktivitetsmeddelande',
        sessionTimeOutInHours: 'Session Time Out',
        enterSessionTimeOutWindowInHours:
          'Ange tidsfönstret för sessionstiden i timmar',
        sessionTimeOutInHoursTooltip: `Ange varaktigheten efter vilken chattsessionen automatiskt kommer att löpa ut
         på grund av inaktivitet. Chattflödet startar om om användaren skickar något meddelande efter att sessionen har löpt ut.`,
        restartChatFlowTriggers: 'Starta om chattflödet - Triggers',
        enterKeyWordsToRestartChatAndhitEnter:
          'Ange nyckelord för att starta om chatten och tryck på Enter',
        restartChatFlowTriggersTooltip: `Specificera nyckelord här som, när de skrivs av
        användaren och skickas, kommer att utlösa en omstart av chatten. Detta gör det möjligt för användare att starta om konversationsflödet när som helst.
        Tryck på Enter efter att ha lagt till varje nyckelord för att lägga till flera nyckelord.`,
        liveChatTriggers: 'Live Chatt - Triggers',
        enterKeyWordsToTriggerLiveChatAndhitEnter:
          'Ange nyckelord för att utlösa livechatt och tryck på Enter',
        liveChatTriggersTooltip: `Definiera nyckelord som, när de skrivs av av användaren och
        skickas, kommer att initiera en övergång från automatisk chatt till livechatt. Detta är användbart när användare behöver hjälp från en levande agent. Tryck på Enter efter att ha lagt till varje nyckelord för att lägga till flera nyckelord.`,
        messageAfterAutomatedFlowCompleted:
          'Meddelande efter slutfört automatiskt flöde',
        enterYourMessage: 'Ange ditt meddelande',
        messageAfterAutomatedFlowCompletedTooltip: ` Ange ett meddelande som kommer att visas
         för användaren efter att de har slutfört det automatiska
        chattflödet men sessionen har inte löpt ut.`,
        restart: 'Starta om',
        liveChat: 'Live Chatt',
        lineOneForDefaultMessage:
          'Om du har fler frågor eller behöver hjälp, här är vad du kan göra härnäst:',
        to: 'Till',
        restartTheChat: 'starta om chatten',
        simpleTypeRestartAndHitEnter: ` skriv bara 'Starta om' och tryck på Enter.
         Detta tar dig tillbaka till början av vår konversationsflöde.`,
        lineThreeForDefaultMessagePartOne: `Om du vill prata med en`,
        liveAgent: `live agent,`,
        lineThreeForDefaultMessageLastPart: `skriv 'Live Chatt' och tryck på Enter. Vårt team är här för att hjälpa dig i realtid.`,
        saveChanges: 'Spara ändringar',
        discard: 'Släng',
        configureBotsGeneralSettings: `Konfigurera din bots allmänna inställningar`,
        minutes: 'Minuter',
        hours: 'Timmar',
      },
    },
    activateWhatsAppBot: {
      justAStepAway: 'Bara ett steg bort',
      seeHowToUse: 'Se hur man använder',
      testWhatsAppTrialBot: 'Testa din Whatsapp Trial Chatbot',
      sendMessage: 'Skicka meddelande',
      sendWhatsAppMessageOn: 'Skicka oss ett WhatsApp-meddelande på ',
      bySavingInYourContact:
        'genom att spara i dina kontakter och meddelandet börjar med ',
      connect: 'Anslut',
      or: 'ELLER',
      scanQRCode: 'Skanna QR-koden',
      yourPhoneWillOpen:
        'Din telefon kommer att öppna ett förifyllt meddelande som ska skickas till vårt Sandbox-nummer. Tryck på "Skicka" på WhatsApp',
      sendVerificationCode: 'Skicka verifikationskod',
      copyAndEnterCode: 'Kopiera och ange 6-siffrig kod',
      shareWhereYouWant:
        'Dela var du vill och omdirigera användare till din WhatsApp-bot med ett enda klick',
      youShouldHaveReceived:
        'Du borde ha fått en 6-siffrig kod på ditt WhatsApp-nummer',
      EnterYourPhoneNumber: 'Ange ditt telefonnummer',
      send: 'Skicka',
      sixDigitCode: 'Ange 6-siffrig kod',
      pleaseNote:
        'Observera: 6-siffrig verifikationskod kan ta upp till 3 minuter. Vänta innan du skickar den igen.',
      resendVerificationCode: 'Skicka verifikationskoden igen',
      verify: 'Verifiera',
      providePhoneNumber:
        'Ange det nummer du vill använda för testning',
      demoBotisReady: 'Fantastiskt! Din demo-bot är redo att användas',
      placeHolder: {
        phone: 'Ange ditt telefonnummer',
        code: 'Ange verifieringskoden',
      },
    },
  },
  integrations: {
    thirdPartyAppsIntegration: 'Integration med tredjepartsappar',
    thirdPartyApps: 'Tredjepartsappar',
    customApps: 'Anpassade appar',
    preview: 'Förhandsgranska',
    test: 'Testa',
    install: 'Installera',
    appTooltip: {
      clickToInstallYourBotToSelectedPlatform:
        'Klicka för att installera din bot på den valda plattformen',
      TOOLTIP_MY_INTEGRATION_TITLE:
        'Integrera dina skräddarsydda skapade appar med din bot',
      TOOLTIP_ALL_INTEGRATION_TITLE:
        'Anslut din bot med tillgängliga tredjepartsappar/CRM',
    },
    allIntegration: {
      list: {
        thirdPartyAppsIntegrations: 'Integrationer med tredjepartsappar',
        integrateYourBotWithListedCrms:
          'Integrera din bot med en av de listade apparna/CRM.',
        help: 'Hjälp',
        name: 'Namn',
        status: 'Status',
        action: 'Åtgärd',
        chatGpt: 'ChatGPT',
        addOn: 'Tillägg',
        purchased: 'Köpt',
        readyToRideGptWave: 'Redo att rida på GPT-vågen? Integrera nu.',
        purchase: 'Köp',
        notConnected: 'Ej ansluten',
        integrated: 'Integrerad',
        configure: 'Konfigurera',
        connected: 'Ansluten',
        edit: 'Redigera',
        connect: 'Anslut',
        requestYourIntegration: 'Begär din integration',
        toRequestNewIntegration:
          'För att begära ny integration, ange nedanstående uppgifter och' +
          ' sedan återkommer vi till dig.',
        // name: 'Namn',
        emailId: 'E-post ID',
        integrationName: 'Integrationsnamn',
        contactNumber: 'Kontaktnummer',
        howSoonYouWantToAddThisIntegration:
          'Hur snart vill du lägga till denna integration',
        sendRequest: 'Skicka förfrågan',
        cancel: 'Avbryt',
        requestSent: 'Förfrågan skickad!',
        yourRequestSuccessfullySent:
          'Din förfrågan om ny integration har skickats framgångsrikt.',
        goBack: 'Gå tillbaka',
        disconnect: 'Koppla från',
        OopsIntegrationAreNotAvailable:
          'Hoppsan! Integrationer är inte tillgängliga i ',
        pleaseUpgradeTo: ' Var vänlig uppgradera till ',
        planForIntegration: ' för integrationer.',

        placeholders: {
          searchIntegrationByName: 'Sök integration efter namn',
          enterTeamMemberName: 'Ange teammedlemmens namn',
          enterEmailId: 'Ange e-postadress',
          enterIntegrationName: 'Ange integrationsnamn',
          searchCountry: 'Sök land',
          enterContactNumber: 'Ange kontaktnummer',
          addComment: 'Lägg till kommentar',
        },
        noDataFound: {
          integrations: 'Integrationer',
          noIntegrationsFound: 'Inga integrationer hittades!',
        },
        appTooltip: {
          nameOfAppOrCrm: 'Namn på app/CRM',
          statusAsConnectedOrNotConnected:
            'Status som ansluten / ej ansluten',
          clickToConnectToAppOrCrm: 'Klicka för att ansluta till app/CRM',
        },
        feedbackModal: {
          submit: 'Skicka in',
        },
      },
      providers: {
        pabbly: {
          newLeadHooks: 'Nya Lead Hooks',
          newMessageHooks: 'Nya meddelandehooks',
          addParameters: '',
          update: 'Uppdatera',
          connect: 'Anslut',
          botId: 'Bot Id',
          toolTip: {
            copyBotId: `Hämta ditt bot-id för att sömlöst integrera Pabbly med ${brand} för att automatisera åtgärder på Pabbly`,
          },
          placeholders: {
            enterYourPabblyWebhookUrl: 'Ange din Pabbly Webhook URL',
          },
        },
        agileCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          agileCrmDomain: 'Agile CRM-domän',
          nameIsRequired: 'Namn krävs',
          emailAddress: 'E-postadress',
          apiToken: 'API-token',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          questionColon: 'Fråga:',
          addParameter: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            exampleSite: 'https://företag.agilecrm.com',
            exampleEmail: 'exempel@företag.extension',
            enterTokenHere: 'Ange token här',
          },
        },
        appTivo: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          apiKey: 'Api-nyckel',
          accessKey: 'Åtkomstnyckel',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterApiKeyHere: 'Ange Api-nyckel här',
            enterAccessKeyHere: 'Ange åtkomstnyckel här',
          },
        },
        autoPilot: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          apiToken: 'API-token',
          nameIsRequired: 'Namn krävs',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterApiToken: 'Ange API-token',
          },
        },
        bitrixCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          nameColon: 'Namn:',
          inboundWebhookUrl: 'Inbound webhook-url',
          nameIsRequired: 'Namn krävs',
          leadTitle: 'Lead-titel',
          source: 'Källa',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterInboundWebhookUrl: 'Ange Inbound webhook-url...',
            enterTitle: 'Ange titel',
            enterSource: 'Ange källa',
          },
        },
        calendarHeroCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          apiToken: 'API-token',
          connect: 'Anslut',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterTokenHere: 'Ange token här',
          },
        },
        capsuleCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          apiToken: 'API-token',
          nameIsRequired: 'Namn krävs',
          testLead: 'Testa Lead',
          connect: 'Anslut',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterApiToken: 'Ange API-token',
          },
        },
        chakraCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          apiToken: 'API-token',
          testLead: 'Testa Lead',
          connect: 'Anslut',
          selectTheQuestion:
            'Välj frågan vars användarsvar du vill skicka som värde',
          mapWith: 'kartlägg med',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterApiToken: 'Ange API-token',
            attributes: 'Attribut (nyckel)',
            values: 'värden',
          },
        },
        chatGpt: {
          chatGptApiKey: 'ChatGPT (Open AI) API-nyckel',
          chatGpt: 'ChatGPT (Open AI)',
          gpt3: 'GPT-3.5 (Lägre kostnad, Genomsnittlig noggrannhet)',
          gpt4: 'GPT-4 (Högre kostnad, Högre noggrannhet)',
          gptAssistant: 'Assistants Beta* (Premiumkostnad, Överlägsen noggrannhet)',
          readyToRideWave: 'Redo att rida på GPT-vågen? Integrera nu.',
          doNotHaveAnyApiKeyNeedHelp: `Har du ingen API-nyckel, behöver hjälp?`,
          authenticate: 'Autentisera',
          nowYouCanAccessChatGpt:
            'Nu kan du komma åt Chat GPT-komponenten i chattflödesbyggaren',
          paymentSuccessful: 'Betalning lyckades!',
          paymentHasBeenCompletedSuccessfully:
            'Betalningen har slutförts framgångsrikt. Du är redo att träna din bot',
          cancel: 'Avbryt',
          trainNow: 'Träna nu',
          paymentInProgress: 'Betalning pågår...',
          apiKey: 'ChatGPT API-nyckel',
          model: 'Modell',
          integrateWithChatGPT: 'Integrera med ChatGPT',
          updateKey: 'Uppdatera nyckel',
          connect: 'Anslut',
          update: 'Uppdatera',
          placeholders: {
            chatGptApiKey: 'ChatGPT (Open AI) API-nyckel',
          },
        },
        closeCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          apiToken: 'API-token',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          leadId: 'Lead Id',
          selectLeadId: 'Välj LeadId',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterTokenHere: 'Ange token här',
          },
        },
        copperCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          emailAddress: 'E-postadress',
          leadTitle: 'Lead-titel',
          apiToken: 'API-token',
          nameIsRequired: 'Namn krävs',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            exampleEmail: 'exempel@företag.extension',
            enterYourLeadTitle: 'Ange din Lead-titel',
            enterTokenHere: 'Ange token här',
          },
        },
        dripCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          dripCrmAccountId: 'Drip CRM-konto-id',
          apiToken: 'API-token',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterAccountIdHere: 'Ange konto-id här',
            enterYourTokenHere: 'Ange ditt token här',
          },
        },
        elevioCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          apikey: 'Api Key',
          accessToken: 'Access Token',
          connect: 'Anslut',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          selectParameter: 'Välj parameter',
          disconnect: 'Koppla från',
          update: 'Uppdatera',
          save: 'Spara',
          placeholders: {
            enterApiKeyHere: 'Ange Api Key här',
            enterTokenHere: 'Ange Token här',
          },
        },
        engageBay: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          apiKey: 'API-nyckel',
          nameIsRequired: 'Namn krävs',
          connect: 'Anslut',
          questionColon: 'Fråga:',
          testLead: 'Testa Lead',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterApiToken: 'Ange API-token',
          },
        },
        extraEdge: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          authToken: 'AuthToken',
          source: 'Källa',
          connect: 'Anslut',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterAuthTokenHere: 'Ange AuthToken här',
            enterSourceHere: 'Ange källa här',
          },
        },
        facebookPixel: {
          facebookPixel: 'Facebook Pixel',
          getInsight: `Få insikter som förvandlar ditt företag till ett företag med BotPenguins Google Analytics-integration`,
          pixelId: 'Facebook Pixel Id',
          connect: 'Anslut',
          disconnect: 'Koppla från',
          placeholders: {
            enterYourId: 'Ange Facebook Pixel Id',
          },
        },
        firmao: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          companyName: 'Företagsnamn',
          emailAddress: 'E-postadress',
          password: 'Lösenord',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapsWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterCompanyName: 'Ange företagsnamn',
            enterEmailAddress: 'Ange e-postadress',
            enterPassword: 'Ange lösenord',
          },
        },

        firstPromoterCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          apiKey: 'API-nyckel',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterApiKeyHere: 'Ange apiKey här',
          },
        },
        flowlu: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          flowluDomain: 'Flowlu Domain',
          apiToken: 'API-token',
          title: 'Titel',
          connect: 'Anslut',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            exampleDomain: 'https://yourcompany.flowlu.com',
            enterTokenHere: 'Ange Token här',
            enterYourLeadTitle: 'Ange din Lead-titel',
          },
        },
        freshdeskCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          freshdeskDomain: 'Freshdesk Domain',
          apiToken: 'API-token',
          nameIsRequired: 'Namn krävs',
          connect: 'Anslut',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            exampleDomain: 'https://yoursubdomain.freshdesk.com',
            enterTokenHere: 'Ange Token här',
          },
        },
        freshworksCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          freshworkCrmDomain: 'Freshwork CRM Domain',
          apiToken: 'API-token',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            exampleDomain: 'https://yourcompany.myfreshworks.com',
            enterToken: 'Ange Token här',
          },
        },
        frontApp: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          apiToken: 'API-token',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          mapWith: 'kartlägg med',
          select: 'Välj',
          update: 'Uppdatera',
          disconnect: 'Koppla från',
          placeholders: {
            enterApiToken: 'Ange API-token',
          },
        },
        getResponseCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          apiKey: 'API-nyckel',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          campaignList: 'Kampanjlista',
          selectCampaign: 'Välj kampanj',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterTokenHere: 'Ange Token här',
          },
        },
        googleAnalytics: {
          googleAnalytics: 'Google Analytics',
          getInsights: `Få insikter som förvandlar ditt företag till ett företag med BotPenguins Google Analytics-integration`,
          measurementId: 'Mätnings-ID',
          connect: 'Anslut',
          disconnect: 'Koppla från',
          placeholders: {
            enterYourId: 'Ange ditt ID',
          },
        },
        googleCalendar: {
          testLead: 'Testa Lead',
          name: 'Namn:',
          email: 'E-post:',
          appointmentSummary: 'Sammanfattning av möte',
          appointmentDescription: 'Beskrivning av möte',
          addParameters: ' Lägg till parametrar',
          questionColon: 'Fråga:',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          pause: 'Paus',
          resume: 'Återuppta',
          disconnect: 'Koppla från',
          reconnect: 'Återanslut',
        },
        googleContacts: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          name: 'Namn :',
          email: 'E-post : ',
          testLead: 'Testa Lead',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
        },
        googleRedirect: {},
        googleSheet: {
          testLead: 'Testa Lead',
          title: 'Titel',
          questionColon: 'Fråga:',
          addParameters: 'Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          update: 'Uppdatera',
          save: 'Spara',
          pause: 'Paus',
          resume: 'Återuppta',
          disconnect: 'Koppla från',
          reconnect: 'Återanslut',
          placeholders: {
            mappingValues: 'Kartläggningsvärden',
          },
        },
        googleTask: {
          youHaveSuccessfullyCreatedIntegration: `You've successfully created Integration. Now, you can configure it.`,
          name: 'Namn:',
          email: 'E-post:',
          taskList: 'Uppgiftslista',
          testLead: 'Testa Lead',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          pause: 'Paus',
          resume: 'Återuppta',
          disconnect: 'Koppla från',
          reconnect: 'Återanslut',
        },
        grooveHq: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          apiToken: 'API-token',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          questionColon: 'Fråga:',
          select: 'Välj',
          addParameters: ' Lägg till parametrar',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterTokenHere: 'Ange Token här',
          },
        },
        helpCrunchCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          apiKey: 'API-nyckel',
          connect: 'Anslut',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterApiHere: 'Ange api här',
          },
        },
        helpDeskCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          testLead: 'Testa Lead',
          accountId: 'Konto-ID',
          accessToken: 'Åtkomsttoken',
          connect: 'Anslut',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterAccountIdHere: 'Ange konto-ID här',
            enterAccessTokenHere: 'Ange åtkomsttoken här',
          },
        },
        helpDocsCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          apiToken: 'API-nyckel',
          connect: 'Anslut',
          questionColon: 'Fråga:',
          testLead: 'Testa Lead',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterTokenHere: 'Ange Token här',
          },
        },
        helpLink: {
          help: 'Hjälp',
        },
        helpRaceCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          helpRaceCrmDomain: 'Helprace CRM Domain',
          emailAddress: 'E-postadress',
          apiToken: 'API-nyckel',
          connect: 'Anslut',
          update: 'Uppdatera',
          placeholders: {
            exampleDomain: 'https://company.helprace.com',
            exampleEmail: 'example@company.extension',
            token: 'Token',
          },
        },
        helpShiftCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          domainName: 'Domännamn',
          apiKey: 'API-nyckel',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterTokenHere: 'Ange Token här',
          },
        },
        hubspotCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          apiToken: 'API-token',
          nameIsRequired: 'Namnet krävs',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          selectTheQuestion: 'Välj frågan vars användarsvar du vill skicka som värde',
          placeholders: {
            enterApiToken: 'Ange API-token här',
            values: 'värden',
          },
        },
        infobipCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          apiKey: 'API-nyckel',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterApiHere: 'Ange api här',
          },
        },
        insightlyCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          apiToken: 'API-token',
          nameIsRequired: 'Namnet krävs',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterApiToken: 'Ange API-token här',
          },
        },
        jiraCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          apiToken: 'API-token',
          emailAddress: 'E-postadress',
          apiUrl: 'API URL',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          selectProjectName: 'Välj projektnamn',
          selectIssueType: 'Välj ärendetyp',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapsWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterTokenHere: 'Ange token här',
            enterEmailAddress: 'Ange e-postadress här',
            exampleUrl: 'https://exempel.atlassian.net',
          },
        },
        jogetCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          apiUrl: 'API URL',
          nameIsRequired: 'Namnet krävs',
          apiKey: 'API-nyckel',
          apiId: 'API ID',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          mapWith: 'kartlägg med',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          selectTheQuestion: 'Välj frågan vars användarsvar du vill skicka som värde',
          placeholders: {
            enterApiUrl: 'Ange API URL här',
            enterApiKey: 'Ange API-nyckel här',
            enterApiId: 'Ange API ID här',
            attributes: 'Attribut (nyckel)',
            values: 'värden',
          },
        },
        karmaCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          apiKey: 'API-nyckel',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterTokenHere: 'Ange Token här',
          },
        },
        kylasCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          apiToken: 'API Token',
          nameIsRequired: 'Namnet krävs',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterApiToken: 'Ange API Token här',
          },
        },
        leadSquared: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          accessKey: 'Accessnyckel',
          secretKey: 'Hemlig nyckel',
          connect: 'Anslut',
          apiLogs: 'API-loggar',
          testLead: 'Testa Lead',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          udpate: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          filterApplied: 'filter applicerad',
          retry: 'Försök igen',
          back: 'Tillbaka',
          filterYourLeads: 'Filtrera dina leads',
          filterOn: 'Filtrera på',
          filterBy: 'Filtrera efter',
          discard: 'Förkasta',
          applyFilter: 'Använd filter',
          loadMore: 'Ladda mer',
          placeholders: {
            enterAccessKeyHere: 'Ange Accessnyckel här',
            enterSecretKeyHere: 'Ange hemlig nyckel här',
            attributes: 'Attribut (nyckel)',
            values: 'värden',
          },
          appTooltip: {
            filterDataBasedOnResponse: 'Filtrera data baserat på svar',
          },
        },
        liveAgentCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          apiKey: 'API-nyckel',
          apiUrl: 'API URL',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterApiHere: 'Ange api här',
            exampleUrl: 'https://comapanyName.ladesk.com',
          },
        },
        microsoftTeams: {
          downloadPackage: 'Ladda ner Microsoft Teams app-paketet',
          downloadApp: 'Ladda ner appen',
          wantToLearnHowToUploadIt: 'Vill du lära dig hur du laddar upp den?',
          needHelp: 'Behöver du hjälp?',
        },
        moengageUser: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          apiUrl: 'API URL',
          appId: 'APP ID',
          nameIsRequired: 'App ID krävs',
          dataApiKey: 'DATA API KEY',
          dataApiKeyIsRequired: 'Data API Key krävs',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          addParameters: ' Lägg till parametrar',
          mapWith: 'kartlägg med',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          selectTheQuestion: 'Välj frågan vars användarsvar du vill skicka som värde',
          placeholders: {
            enterApiUrl: 'Ange API URL här',
            enterAppId: 'Ange APP ID här',
            enterDataApiKey: 'Ange DATA API KEY här',
            attributes: 'Attribut (nyckel)',
            pressForMappingQuestion: 'Tryck / För kartläggningsfråga',
          },
        },
        nethuntCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          emailAddress: 'E-postadress',
          apiKey: 'API-nyckel',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          leadId: 'Lead Id',
          selectLeadId: 'Välj LeadId',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterEmailHere: 'Ange e-post här',
            enterApiKeyHere: 'Ange API-nyckel här',
          },
        },
        nimbleCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          apiKey: 'API-nyckel',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterApiToken: 'Ange API-token här',
          },
        },
        noCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          noCrmDomain: 'Nocrm-domän',
          leadTitle: 'Lead-titel',
          titleIsRequired: 'Titel krävs',
          token: 'Token',
          tokenIsRequired: 'Token krävs',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            exampleDomain: 'https://YOUR_SUBDOMAIN_HERE.nocrm.io',
            enterYourLeadTitle: 'Ange din Lead-titel',
            enterYourToken: 'Ange din Token',
          },
        },
        nutshellCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          emailAddress: 'E-postadress',
          apiKey: 'API-nyckel',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterApiToken: 'Ange API-token här',
          },
        },
        onpipelineCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          secretToken: 'Hemlig token',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterTokenHere: 'Ange Token här',
          },
        },
        ontraportCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          appId: 'App Id',
          appIdIsRequired: 'App Id krävs',
          apiKey: 'API-nyckel',
          apiKeyIsRequired: 'API-nyckel krävs',
          connect: 'Anslut',
          update: 'Uppdatera',
          disconnect: 'Koppla från',
          placeholders: {
            appId: 'App Id',
            apiKey: 'API-nyckel',
          },
        },
        outlook: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          clientId: 'Klient Id',
          connect: 'Anslut',
          clientSecret: 'Klient Hemlighet',
          testLead: 'Testa Lead',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          save: 'Spara',
          update: 'Uppdatera',
          disconnect: 'Koppla från',
          placeholders: {
            enterClientIdHere: 'Ange Klient-ID här',
            enterClientSecretHere: 'Ange Klientens hemlighet här',
          },
        },
        pipedriverCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          pipedriverDomain: 'Pipedriver-domän',
          domainIsRequired: 'Domän krävs',
          apiToken: 'API Token',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            exampleDomain: 'https://yourcompany.pipedrive.com',
            enterTokenHere: 'Ange token här',
          },
        },
        pipeline: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          apiKey: 'API-nyckel',
          apiKeyIsRequired: 'API-nyckel krävs',
          appKey: 'APP-nyckel',
          appKeyIsRequired: 'APP-nyckel krävs',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterApiKey: 'Ange API-nyckel här',
            enterAppKey: 'Ange APP-nyckel här',
          },
        },
        plivoSmsBot: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          authId: 'Autentiserings-ID',
          authToken: 'Autentiserings-token',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterTokenHere: 'Ange Token här',
          },
        },
        recurlyCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          apiKey: 'API-nyckel',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterApiHere: 'Ange API här',
          },
        },
        salesfareCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          apiKey: 'API-nyckel',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterApiKey: 'Ange API-nyckel här',
          },
        },
        salesforce: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          domain: 'Domän',
          clientId: 'Klient-ID',
          clientSecret: 'Klientens hemlighet',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterDomainHere: 'Ange domän här',
            enterClientIdHere: 'Ange Klient-ID här',
            enterClientSecretHere: 'Ange Klientens hemlighet här',
          },
        },
        sendInBlueCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          apiKey: 'Api-nyckel',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          addEventsAndTemplates: 'Lägg till händelser och mallar:',
          add: ' Lägg till',
          question: 'Fråga',
          reply: 'Svara',
          requestBody: 'Begäran Body',
          validateJson: 'Validera JSON',
          emailAddress: 'E-postadress',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          selectTheQuestion: 'Välj frågan vars användarsvar du vill skicka som värde',
          placeholders: {
            enterApiHere: 'Ange API här',
            enterTemplateId: 'Ange mall-ID här',
            typeYourJsonCodeHere: 'Skriv din JSON-kod här',
          },
          appTooltip: {
            typeYourJsonCode: 'Skriv din JSON-kod',
            clickToValidateJsonCode: 'Klicka för att validera JSON-koden',
          },
        },
        shipwayCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          userName: 'Användarnamn',
          licenseKey: 'Licensnyckel',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterNameHere: 'Ange namn här',
            enterKeyHere: 'Ange nyckel här',
          },
        },
        supportBeeCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          apiToken: 'API-token',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterTokenHere: 'Ange Token här',
          },
        },
        simplybook: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          company: 'Företag',
          loginId: 'Inloggnings-ID',
          password: 'Lösenord',
          testLead: 'Testa Lead',
          connect: 'Anslut',
          selectTheQuestion: 'Välj frågan vars användarsvar du vill skicka som värde',
          mapWith: 'kartlägg med',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          selectParameter: 'Välj parameter',
          placeholders: {
            enterCompanyHere: 'Ange företagsnamn här',
            enterLoginIdHere: 'Ange inloggnings-ID här',
            enterPasswordHere: 'Ange lösenord här',
            values: 'värden',
          },
        },
        twilio: {
          description: 'Brug Twilio til at foretage klare taleopkald til dine kunder når som helst.',
          accountSid: 'Konto SID',
          phoneNumber: 'Telefonnummer',
          twiMlSid: 'TwiML App SID',
          apiKey: 'API-nøgle',
          apiSecret: 'API Secret',
          apiUrl: 'App URL (POST)',
          required: 'påkrævet',
          accountSidRequired: 'Konto Sid er ',
          phoneNumberRequired: 'Telefonnummer er ',
          sidRequired: 'TwiML App SID er ',
          apiKeyRequired: 'API-nøgle er ',
          apiSecretRequired: 'API Secret er ',
          update: 'Opdater',
          connect: 'Forbind',
          disconnect: 'Frakobl',
        },
        teamGate: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          applicationKey: 'Applikationsnyckel',
          authToken: 'Autentiserings-token',
          connect: 'Anslut',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterApplicationKeyHere: 'Ange applikationsnyckel här',
            enterTokenHere: 'Ange Token här',
          },
        },
        wealthboxCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          accessToken: 'Access Token',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          question: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterTokenHere: 'Ange Token här',
          },
        },
        webhopersCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          webhoperDomain: 'Webhoper-domän',
          domainIsRequired: 'Domän krävs',
          companyName: 'Företagsnamn',
          companyIsRequired: 'Företag krävs',
          leadSource: 'Leadkälla',
          leadSourceIsRequired: 'Leadkälla krävs',
          division: 'Division',
          divisionIsRequired: 'Division krävs',
          enterPassword: 'Ange lösenord',
          passwordIsRequired: 'Lösenord krävs',
          disconnect: 'Koppla från',
          update: 'Uppdatera',
          connect: 'Anslut',
          placeholders: {
            exampleDomain: 'http://yourcompanydomain',
            enterYourCompanyName: 'Ange ditt företagsnamn',
            enterLeadSource: 'Ange Leadkälla',
            enterDivision: 'Ange Division',
            enterPassword: 'Ange lösenord',
          },
        },
        zapierCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          name: 'Namn:',
          zapier: 'Zapier',
          inboundWebhookUrl: 'Inkommande webhook-url',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterWebhookUrl: 'Ange webhook-url',
          },
        },
        zendeskCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          apiToken: 'API-token',
          emailAddress: 'E-postadress',
          apiUrl: 'API-url',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterEmailAddress: 'Ange e-postadress',
            enterUrlHere: 'Ange URL här',
            enterTokenHere: 'Ange Token här',
          },
        },
        zingtreeCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          apiKey: 'Api-nyckel',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterApiHere: 'Ange API här',
          },
        },
        zohoCrm: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          connect: 'Anslut',
          update: 'Uppdatera',
          disconnect: 'Koppla från',
          companyName: 'Företagsnamn',
          emailAddress: 'E-postadress',
          phone: 'Telefon',
          countryCode: 'Landskod',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          save: 'Spara',
          testLead: 'Testa Lead',
          crmExtensionUrl: 'CRM-förlängnings-URL',
          installExtension: 'Installera förlängningen',
          toolTip: {
            crmExtensionUrl:
              'Kör denna URL för att lägga till Zoho-förlängningen och skicka meddelanden till leads på WhatsApp från Zoho CRM.',
          },
        },
        zohoDesk: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          connect: 'Anslut',
          disconnect: 'Koppla från',
          testLead: 'Testa Lead',
          emailAddress: 'E-postadress',
          selectOrganizationName: 'Välj organisationsnamn',
          selectDepartmentName: 'Välj avdelningsnamn',
          addParameters: ' Lägg till parametrar',
          questionColon: 'Fråga:',
          select: 'Välj',
          mapsWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
        },
        zohoProject: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          testLead: 'Testa Lead',
          connect: 'Anslut',
          disconnect: 'Koppla från',
          projectsList: 'Projektlista',
          selectProjectsName: 'Välj projektnamn',
          projectsTaskList: 'Projekts uppgiftslista',
          selectTaskListName: 'Välj uppgiftslistans namn',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
        },
        wooCommerce: {
          configure: 'Konfigurera',
          automatedMessage: 'Automatiskt meddelande',
          configureTab: {
            wooCommercePluginApiKey: 'WooCommerce Plugin API Key',
            downloadWooCommercePlugin: 'Ladda ner WooCommerce Plugin',
          },
          automatedMessageTab: {
            abandonedRecoveryMessage: 'Meddelande om övergivet återställning',
            configureAutomatedRecoveryMessagesToWinBackCustomerWhoAbandonedTheirCarts:
              'Konfigurera automatiska återställningsmeddelanden för att vinna tillbaka kunder som övergav sina vagnar',
            enableAbandonedCartRecoveryMessaegs:
              'Aktivera meddelanden om återhämtning av övergivna kundvagnar',
            selectTemplate: 'Välj mall',
            sendMessageAfter: 'Skicka meddelande efter',
            templateMessage: 'Mallmeddelande',
            saveChanges: 'Spara ändringar',
            selectFile: 'Välj fil',
            orderCompleted: 'Order slutförd',
            templateHeader: 'Mallhuvud',
            orderFulfillMent: 'Orderuppfyllelse',
            enableOrderConfirmationMessages:
              'Aktivera meddelanden om orderbekräftelse',
            sendAnOrderConfirmationMessageAsSoonAsACustomerPlacesAnOrder:
              'Skicka ett orderbekräftelsemeddelande så snart en kund lägger en beställning.',
            orderShipmentMessageIsSentWhenYouFulfillAnOrder:
              'Orderförsändelsemeddelandet skickas när du uppfyller en beställning.',
            enableOrderFulfillmentMessages: 'Aktivera meddelanden om orderuppfyllnad',
            returnExchangeRequest: 'Retur-/utbytisbegäran',
            theMessageIsSentAfterARefundIsRequested:
              'Meddelandet skickas efter att en återbetalning har begärts',
            enableOrderRefundMessages: 'Aktivera meddelanden om orderåterbetalning',
          },
        },
        shopify: {
          configure: 'Konfigurér',
          automatedMessage: 'Automatisk besked',
          configureTab: {
            enterYourShopifyDomain: 'Indtast dit Shopify-domæne',
            disconnect: 'Afbryd forbindelsen',
            integrated: 'Integreret',
            install: 'Installer',
          },
          automatedMessageTab: {
            shopifyAutomatedMessage: 'Shopify Automatisk Besked',
            viewYourCashOnDeliveryInsights: 'Se dine Cash on Delivery-insights.',
            noTemplateFound: 'Ingen skabelon fundet',
            hours: 'Timer',
            minutes: 'Minutter',
            saveChanges: 'Gem ændringer',
            selectTemplate: 'Vælg skabelon',
            templateMessage: 'Skabelonbesked',
            selectFile: 'Vælg fil',
            templateHeader: 'Skabelonheader',
            sendMessageAfter: 'Send besked efter',
            select: 'Vælg',
            abandonedCartRecovery: 'Gendannelse af forladt indkøbsvogn',
            abandonedCartDescription: 'Underret brugere om forladte indkøbsvogne for opfølgning via WhatsApp-chat.',
            enableAbandonedCartRecoveryMessages: 'Aktivér beskeder om gendannelse af forladt indkøbsvogn',
            orderCreated: 'Ordre oprettet',
            orderCreatedDescription: 'Send kunder øjeblikkelige underretninger om deres nye ordreplaceringer.',
            enableOrderCreatedMessages: 'Aktivér beskeder om oprettelse af ordre',
            codOrderTracking: 'COD Order Tracking',
            codOrderTrackingDescription: 'Giv et sporingslink i WhatsApp-chat for at lade brugerne spore kontant ved levering ordrer i realtid.',
            enableCodOrderTrackingMessages: 'Aktivér beskeder om sporing af COD-ordre',
            orderFulfilled: 'Ordre opfyldt',
            orderFulfilledDescription: 'Send underretninger til dine kunder ved vellykket ordreopfyldelse.',
            enableOrderFulfilledMessages: 'Aktivér beskeder om opfyldelse af ordre',
            orderCancelled: 'Ordre annulleret',
            orderCancelledDescription: 'Vis og bekræft annullerede ordrer effektivt på WhatsApp.',
            enableOrderCancelledMessages: 'Aktivér beskeder om annullering af ordre',
            orderReturnRequestPlaced: 'Ordre om anmodning om returnering placeret',
            orderReturnRequestPlacedDescription: 'Underret kunder, når de placerer en anmodning om returnering i din Shopify-butik.',
            enableOrderReturnRequestPlacedMessages: 'Aktivér beskeder om anmodning om returnering af ordre',
            orderReturned: 'Ordre returneret (refunderet)',
            orderReturnedDescription: 'Send opdateringer til kunder, når deres returneringsordre er opfyldt.',
            enableOrderRefundMessages: 'Aktivér beskeder om refundering af ordre',
          },
        },
        goHighLevel: {
          youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
          apiToken: 'API-token',
          nameIsRequired: 'Namn krävs',
          connect: 'Anslut',
          testLead: 'Testa Lead',
          questionColon: 'Fråga:',
          addParameters: ' Lägg till parametrar',
          select: 'Välj',
          mapWith: 'kartlägg med',
          selectParameter: 'Välj parameter',
          update: 'Uppdatera',
          save: 'Spara',
          disconnect: 'Koppla från',
          placeholders: {
            enterApiToken: 'Ange API-token',
          },
        },
      },
    },
    createIntegration: {
      createNewIntegration: 'Skapa ny integration',
      youDoNotHaveAnyIntegrationSetupAsOfNow:
        'Du har för närvarande ingen integration inställd.',
      pleaseCreateOneToIntegrateYourFavourite:
        'Vänligen skapa en för att integrera din favorit',
      appsWith: 'apps med ',
      integrationName: 'Integrationsnamn',
      integrationNameIsRequired: 'Integrationsnamn krävs',
      continue: 'Fortsätt',
      addAnImageToRepresentYourIntegration:
        'Lägg till en bild för att representera din integration.',
      description: 'Beskrivning',
      submit: 'Skicka',
      youHaveSuccessfullyCreatedIntegration: `Du har skapat integrationen framgångsrikt. Nu kan du konfigurera den.`,
      apiUrl: 'API URL',
      pleaseEnterAValidApiUrl: 'Ange en giltig API URL',
      requestMethod: 'Förfrågningsmetod',
      get: 'Hämta',
      post: 'Posta',
      put: 'Lägg',
      patch: 'Lappa',
      queryParameter: 'Förfrågeparameter',
      addParameter: ' Lägg till parameter',
      mapsWith: ' kartlägg med',
      question: 'Fråga',
      addQuestion: ' Lägg till fråga',
      select: 'Välj',
      selectParameter: 'Välj parameter',
      header: 'Rubrik ',
      addHeader: ' Lägg till rubrik',
      value: 'Värde',
      connect: 'Anslut',
      requestBody: 'Förfrågningskropp',
      validate: 'Validera',
      key: 'Nyckel',
    },
    myIntegrations: {
      integrationDetails: {
        canAlsoBeIntegratedWith: ' kan också integreras med denna gratis CRM.',
        apiUrl: 'API URL',
        pleaseEnterAValidApiUrl: 'Ange en giltig API URL',
        requestMethod: 'Förfrågningsmetod:',
        get: 'Hämta',
        post: 'Posta',
        put: 'Lägg',
        patch: 'Lappa',
        queryParameter: 'Förfrågeparameter',
        addParameter: ' Lägg till parameter',
        header: 'Rubrik ',
        addHeader: ' Lägg till rubrik',
        requestBody: 'Förfrågningskropp',
        validateJson: 'Validera JSON',
        connect: 'Anslut',
        update: 'Uppdatera',
        delete: 'Radera',
        selectTheQuestion:
          'Välj frågan vars användarsvar du vill skicka som värde',
        appTooltip: {
          typeYourJsonCode: 'Skriv din JSON-kod',
          clickToValidateJsonCode: 'Klicka för att validera JSON-koden',
        },
      },
      list: {
        customAppsIntegrations: 'Anpassade appar Integrationer',
        integrateYourAppsWith: 'Integrera dina egna appar med ',
        help: 'Hjälp',
        addIntegration: ' Lägg till integration',
        name: 'Namn',
        status: 'Status',
        action: 'Åtgärd',
        insatlled: 'Installerad',
        edit: 'Redigera',
        connect: 'Anslut',
        requestYourIntegration: 'Begär din integration',
        toRequestNewIntegration:
          'För att begära ny integration, ange nedanstående uppgifter och' +
          ' sedan återkommer vi till dig.',
        emailId: 'E-postadress',
        integrationName: 'Integrationsnamn',
        contactNumber: 'Kontaktnummer',
        howSoonYouWantToAddThisIntegration:
          'Hur snart vill du lägga till denna integration',
        sendRequest: 'Skicka förfrågan',
        cancel: 'Avbryt',
        delete: 'Radera',
        oopsOwnIntegrationsAreSupportedOnlyIn:
          'Hoppsan! Dina egna integrationer stöds endast i',
        plan: 'Plan',
        pleaseUpgradeTo: 'Vänligen uppgradera till',
        toCreateOwnIntegrations: 'för att skapa egna integrationer',
        appTooltip: {
          integrations: 'Integrationer',
          noIntegrationsFound: 'Inga integrationer hittades!',
          nameOfYourApp: 'Namn på din app',
          clickToConnectApp: 'Klicka för att ansluta appen',
          statusAsConnectedOrNotConnected:
            'Status som ansluten / ej ansluten',
        },
      },
    },
  },
};
